interface Tool {
  slug: string;
  name: string;
  title?: string;
  description?: string;
  keys?: string;
  current?: boolean;
  h1?: string;
  icon?:string
}

interface TypeTools {
  locale: string;
  data: Array<Tool>;
}

export default class ToolLocale {
  public data: Array<Tool> = [];
  public tool: Tool = {
    name: "",
    slug: "",
  };
  public questions: Array<{
    question: string;
    answer: string;
  }> = [];
  public current_type: string = "text";
  constructor() {
    const { locale } = useI18n();
    const route = useRoute();

    this.data =
      dataLocales.find((item) => item.locale == locale.value)?.data ??
      dataLocales[0].data;
    this.data.forEach((item) => {
      item.current = false;
      if (route.params.type) {
        if (route.params.type == item.slug) {
          item.current = true;
          this.current_type = item.slug;
          this.tool = item;
        }
      } else {
        if (!item.slug) {
          item.current = true;
          this.tool = item;
        }
      }

      const questionData =
        questions.find((item) => item.locale == locale.value)?.data ??
        questions[0].data;
      for (let i = 0; i < questionData.length; i++) {
        const element = questionData[i];
        if (element.name == this.current_type) {
          this.questions = element.questions;
          break;
        }
      }
    });
  }
}

// text
// url
// document
// picture
// audio and video
// business card
// WeChat
// form
// batch code
// more tools

const dataLocales: Array<TypeTools> = [
  {
    locale: "en",
    data: [
      {
        name: "Widget",
        slug: "",
        description:
          "Unlock a world of possibilities with QR Gateway, your go-to free SVG QR code generator enriched with the power of customization.",
        title: "QR Gateway - Free Svg QR Code Generator with Logo",
        keys: "QR code generator,Create QR codes,Free QR code maker,Text to QR code generator,Convert text to QR code,Free text to QR code tool,QR code creator,Dynamic QR codes,Static QR codes",
        current: true,
        h1: "The most advanced QR Code Generator with logo online",
        icon:"Stack3Icon"
      },
      {
        name: "Text",
        slug: "text",
        description:
          "Effortlessly generate QR codes from plain text with our intuitive tool.",
        title: "Text to QR Code",
        keys: "QR code generator,Create QR codes,Free QR code maker,Text to QR code generator,Convert text to QR code,Free text to QR code tool,QR code creator,Dynamic QR codes,Static QR codes",
        current: true,
        h1: "Text to QR Code",
        icon:"TextSizeIcon"
      },
      {
        name: "URL",
        slug: "url",
        description:
          "Our free QR code generator creates both static and dynamic codes, allowing you to change the destination URL anytime.",
        title: "URL to QR Code Generator",
        keys: "URL to QR code,Generate QR code from URL,QR code for website,Website QR code generator,Free URL to QR code converter,Online QR code creator,Dynamic QR code for website,QR code for website URL,Custom website QR code,QR code for landing page,QR code for blog post,QR code for online store,QR code for social media profile,QR code for digital marketing campaign,QR code for event registration page,",
        h1: "URL QR Code",
        icon:"LinkIcon"
      },
      {
        name: "Document",
        slug: "document",
        description:
          "Streamline document management and sharing with our free QR code generator, QRGateway. Instantly create QR codes for uploaded files, allowing for easy access to the content through scanning.",
        title: "Document to QR Code Generator",
        keys: "Document to QR code,File to QR code,QR code generator for documents,Convert documents to QR codes,Free document QR code generator,Online QR code creator for files,Document sharing with QR codes,QR code for PDF, Word, Excel, etc.,Create QR codes for documents,Document management with QR codes,QR code for file download,QR code for document access,Dynamic QR codes for documents,QR code for document tracking",
        h1: "Document QR Code",
        icon:"FileTextIcon"
      },
      {
        name: "Image",
        slug: "image",
        description:
          "QRGateway converts images into QR codes with advanced functions. Scan for access to promotions, itineraries, product info, or events with text and pictures. Create custom QR codes for free with QRGateway.",
        title: "Gallery Images to QR Code Generator",
        keys: "picture to QR code,image QR generator,convert image to QR,QR code from picture,QR code from image,photo to QR code,picture-to-code converter,image-to-QR tool,QR code creator for images,QR code maker for photos",
        h1: "Images QR Code",
        icon:"LayoutCollageIcon"
      },
      {
        name: "Audio and Video",
        slug: "multimedia",
        description:
          "With QRGateway, convert your audio or video recordings into shareable QR codes. Distribute your media content by letting others scan the code to access your files. Sharing media has never been easier with QRGateway's audio and video code generation function.",
        title: "Multimedia to QR Code Generator",
        keys: "QR code generator for audio,QR code creator for video,convert media to QR code,audio QR code maker,video QR code generator,shareable QR codes for audio and video,media sharing through QR codes,QR codes for audio and video files,distribute media with QR codes,QR code sharing for multimedia",
        h1: "Multimedia QR Code",
        icon:"VinylIcon",

      },
      {
        name: "Business Card",
        slug: "vcard",
        description:
          "Use our fast and free business card generator to create personal or corporate cards. Enjoy easy sharing, visitor stats, contact dialing, and batch addition. Expand your business and connect with potential clients today",
        title: "Create Business Card QR Codes",
        keys: "Business card QR codes,QR code generator for business cards,Personal business card QR code,Corporate business card QR code,Digital business card QR code,Scan-to-save business card QR code,Contact sharing QR code,Visitor statistics QR code,Batch addition QR code,Address book QR code",
        h1: "VCard QR Code",
        icon:"IdIcon"
      },
      {
        name: "Google Map",
        slug: "map",
        description:
          "Create QR codes for any Google Maps location with our free generator. Share your favorite places with friends, customers, or for marketing purposes. Simply enter the address, customize the design, and download the QR code.",
        title: "Google Maps to QR Code Generator",
        keys: "Google Map QR Code,Map location QR Code,QR Code generator for Google Maps,Embed Google Maps in QR Code,QR Code for business location,Mobile-friendly Google Maps QR Code,GPS QR Code,Location sharing QR Code,Travel itinerary QR Code,QR Code for navigation",
        h1: "Google Map QR Code",
        icon:"Map2Icon"
      },
      {
        name: "Event",
        slug: "event",
        description: "Elevate your event experience through Event QR Codes",
        title: "Create QR Codes for Events",
        keys: "Event QR Code,QR Code for Events,Streamline Event Management,Event Check-in Solution",
        h1: "Event QR Code",
        icon:"CalendarIcon"

      },
      {
        name: "Wifi",
        slug: "wifi",
        description:
          "Simplify the process of sharing Wi-Fi information with this user-friendly QR code generator.",
        title: "Create QR Codes for Wifi",
        keys: "Wi-Fi QR code, QR code generator, network credentials, Wi-Fi access, wireless connection, QR code scanner, Wi-Fi sharing, network security, encryption, easy connectivity.",
        h1: "Wifi QR Code",
        icon:"WifiIcon"
      },
      {
        name: "Email",
        slug: "email",
        description:
          "Enhance convenience and streamline your email sharing with this efficient QR code generator",
        title: "Create QR Codes for Email",
        keys: "Email QR code, QR code generator, contact sharing, email address",
        h1: "Email QR Code",
        icon:"MailIcon"
      },
      {
        name: "SMS",
        slug: "sms",
        description:
          "Simplify communication and expedite message delivery with this user-friendly QR code generator.",
        title: "Create QR Codes for SMS",
        keys: "SMS QR code, QR code generator, message sharing, SMS content",
        h1: "SMS QR Code",
        icon:"MessageIcon"
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        name: "Tiện ích",
        slug: "",
        description:
          "Cá nhân hóa mã QR của bạn một cách dễ dàng bằng cách thêm biểu tượng, làm cho bản quét của bạn không chỉ hoạt động hiệu quả mà còn hấp dẫn về mặt hình ảnh.",
        title: "QR Gateway - Trình tạo mã QR miễn phí",
        keys: "QR code generator, Tạo mã QR, Tạo mã QR miễn phí, Trình tạo mã QR từ văn bản, Chuyển đổi văn bản thành mã QR, Công cụ văn bản thành mã QR miễn phí, Trình tạo mã QR động, Mã QR tĩnh,",
        current: true,
        h1: "Trình tạo mã QR có logo tốt nhất",
      },
      {
        name: "Văn bản",
        slug: "text",
        description:
          "Tạo mã QR một cách dễ dàng từ văn bản đơn giản với công cụ thông minh của chúng tôi.",
        title: "Văn bản thành Mã QR",
        keys: "Máy tạo mã QR, Tạo mã QR, Công cụ tạo mã QR miễn phí, Máy tạo mã văn bản thành mã QR, Chuyển đổi văn bản thành mã QR, Công cụ miễn phí chuyển đổi văn bản thành mã QR, Người tạo mã QR, Mã QR động, Mã QR tĩnh",
        current: true,
        h1: "Văn bản thành Mã QR",
      },
      {
        name: "URL",
        slug: "url",
        description:
          "Trình tạo mã QR miễn phí của chúng tôi tạo cả mã tĩnh và động, cho phép bạn thay đổi URL đích bất cứ lúc nào.",
        title: "Trình tạo mã QR từ URL",
        keys: "Tạo mã QR từ URL, Tạo mã QR cho trang web, Trình tạo mã QR động cho trang web, Mã QR tùy chỉnh cho trang web, Tạo mã QR cho trang đích, Trình tạo mã QR cho cửa hàng trực tuyến, Mã QR cho trang cá nhân mạng xã hội, Tạo mã QR cho chiến dịch tiếp thị kỹ thuật số,",
        h1: "Trình tạo mã QR từ URL",
      },
      {
        name: "Tài liệu",
        slug: "document",
        description:
          "Giảm thiểu quản lý tài liệu và chia sẻ với trình tạo mã QR miễn phí của chúng tôi, QRGateway. Tạo ngay mã QR cho các tệp đã tải lên, cho phép truy cập nội dung dễ dàng thông qua quét mã.",
        title: "Trình tạo mã QR từ tài liệu, Excel và PDF",
        keys: "Tạo mã QR từ tài liệu, Tạo mã QR cho PDF, Word, Excel, Tạo mã QR tài liệu miễn phí, Trình tạo mã QR trực tuyến cho tệp tin, Chia sẻ tài liệu với mã QR, Tạo mã QR cho tải xuống tài liệu, Quản lý tài liệu với mã QR, Mã QR động cho tài liệu, Mã QR để theo dõi tài liệu",
        h1: "Trình tạo mã QR từ tài liệu, Excel và PDF",
      },
      {
        name: "Hình ảnh",
        slug: "image",
        description:
          "QRGateway chuyển đổi hình ảnh thành mã QR với các chức năng nâng cao. Quét để truy cập các khuyến mãi, lịch trình, thông tin sản phẩm hoặc sự kiện với văn bản và hình ảnh. Tạo mã QR tùy chỉnh miễn phí với QRGateway.",
        title: "Trình tạo mã QR từ ảnh",
        keys: "hình ảnh thành mã QR, công cụ tạo mã QR từ hình ảnh, chuyển đổi hình ảnh thành mã QR, mã QR từ hình ảnh, mã QR từ ảnh, chuyển đổi ảnh thành mã QR, công cụ chuyển đổi hình ảnh thành mã QR, trình tạo mã QR cho hình ảnh, trình tạo mã QR cho ảnh",
        h1: "Chuyển đổi hình ảnh thành mã QR",
      },
      {
        name: "Âm thanh, Video",
        slug: "multimedia",
        description:
          "Với QRGateway, bạn có thể chuyển đổi các bản ghi âm hoặc video của mình thành mã QR có thể chia sẻ. Phân phối nội dung truyền thông của bạn bằng cách cho người khác quét mã để truy cập vào tệp của bạn. Chia sẻ phương tiện truyền thông chưa bao giờ dễ dàng hơn với chức năng tạo mã QR âm thanh và video của QRGateway.",
        title: "Trình tạo mã QR từ phương tiện đa phương tiện",
        keys: "trình tạo mã QR cho âm thanh, trình tạo mã QR cho video, chuyển đổi phương tiện thành mã QR, công cụ tạo mã QR cho âm thanh, trình tạo mã QR cho video, mã QR có thể chia sẻ cho âm thanh và video, chia sẻ phương tiện truyền thông qua mã QR, mã QR cho tệp âm thanh và video, phân phối phương tiện truyền thông bằng mã QR, chia sẻ mã QR cho đa phương tiện",
        h1: "Chuyển đổi audio, video, tập tin thành mã QR",
      },
      {
        name: "Danh thiếp",
        slug: "vcard",
        description:
          "Sử dụng trình tạo thẻ visit nhanh và miễn phí của chúng tôi để tạo ra các thẻ visit cá nhân hoặc doanh nghiệp. Tận hưởng việc chia sẻ dễ dàng, thống kê lượt truy cập, quay số liên lạc và thêm hàng loạt liên lạc. Mở rộng doanh nghiệp và kết nối với khách hàng tiềm năng ngay hôm nay.",
        title: "Tạo mã QR cho Thẻ Visit",
        keys: "Mã QR thẻ visit, trình tạo mã QR cho thẻ visit, Mã QR thẻ visit cá nhân, Mã QR thẻ visit doanh nghiệp, Mã QR thẻ visit kỹ thuật số, Mã QR thẻ visit quét để lưu trữ, Mã QR chia sẻ liên lạc, Mã QR thống kê lượt truy cập, Mã QR thêm hàng loạt liên lạc, Mã QR danh bạ",
        h1: "Tạo Thẻ VCard của Bạn",
      },
      {
        name: "Map",
        slug: "map",
        description:
          "Tạo mã QR cho bất kỳ địa điểm Google Maps nào với trình tạo miễn phí của chúng tôi. Chia sẻ những địa điểm yêu thích của bạn với bạn bè, khách hàng hoặc cho mục đích tiếp thị. Chỉ cần nhập địa chỉ, tùy chỉnh thiết kế và tải xuống mã QR.",
        title: "Tạo mã QR cho Google Maps",
        keys: "Mã QR Google Maps, Mã QR địa điểm bản đồ, Trình tạo mã QR cho Google Maps, Nhúng Google Maps vào mã QR, Mã QR cho vị trí kinh doanh, Mã QR thân thiện với di động cho Google Maps, Mã QR GPS, Mã QR chia sẻ địa điểm, Mã QR lịch trình du lịch, Mã QR cho định vị",
        h1: "Google Maps sang Mã QR",
      },
      {
        name: "Sự kiện",
        slug: "event",
        description:
          "Nâng cao trải nghiệm sự kiện của bạn thông qua mã QR Sự kiện",
        title: "Tạo mã QR cho Sự kiện",
        keys: "Mã QR Sự kiện, Mã QR cho Sự kiện, Tinh giản Quản lý Sự kiện, Giải pháp Check-in Sự kiện",
        h1: "Mã QR Sự kiện",
      },
      {
        name: "Wifi",
        slug: "wifi",
        description:
          "Đơn giản hóa quá trình chia sẻ thông tin Wi-Fi với trình tạo mã QR thân thiện người dùng này.",
        title: "Tạo mã QR cho Wifi",
        keys: "Mã QR Wi-Fi, Trình tạo mã QR, thông tin mạng, Truy cập Wi-Fi, kết nối không dây, máy quét mã QR, Chia sẻ Wi-Fi, bảo mật mạng, mã hóa, kết nối dễ dàng.",
        h1: "Mã QR Wifi",
      },
      {
        name: "Email",
        slug: "email",
        description:
          "Tăng cường sự tiện lợi và tinh giản việc chia sẻ email của bạn với trình tạo mã QR hiệu quả này",
        title: "Tạo mã QR cho Email",
        keys: "Mã QR Email, Trình tạo mã QR, chia sẻ thông tin liên hệ, địa chỉ email",
        h1: "Mã QR Email",
      },
      {
        name: "SMS",
        slug: "sms",
        description:
          "Đơn giản hóa giao tiếp và tăng tốc quá trình gửi tin nhắn với trình tạo mã QR thân thiện người dùng này.",
        title: "Tạo mã QR cho SMS",
        keys: "Mã QR SMS, Trình tạo mã QR, chia sẻ tin nhắn, nội dung SMS",
        h1: "Mã QR SMS",
      },
      
    ],
  },
  {
    locale: "fr",
    data: [
      {
        name: "Widget",
        slug: "",
        description:
          "Personnalisez facilement vos codes QR en ajoutant des logos, rendant vos numérisations non seulement fonctionnelles mais visuellement attrayantes.",
        title: "QR Gateway - Générateur de code QR Svg gratuit avec logo",
        keys: "Générateur de codes QR, Créer des codes QR, Fabricant de codes QR gratuit, Générateur de codes QR à partir de texte, Convertir du texte en code QR, Outil de texte gratuit pour les codes QR, Créateur de codes QR, Codes QR dynamiques, Codes QR statiques",
        current: true,
        h1: "Générateur de codes QR",
      },
      {
        name: "URL",
        slug: "url",
        description:
          "Notre générateur de codes QR gratuit crée des codes statiques et dynamiques, vous permettant de modifier l'URL de destination à tout moment.",
        title: "Générateur de codes QR à partir d'URL",
        keys: "URL vers code QR, Générer un code QR à partir d'une URL, Code QR pour site web, Générateur de codes QR pour site web, Convertisseur gratuit d'URL en code QR, Créateur de codes QR en ligne, Code QR dynamique pour site web, Code QR pour URL de site web, Code QR personnalisé pour site web, Code QR pour page de destination, Code QR pour article de blog, Code QR pour boutique en ligne, Code QR pour profil de médias sociaux, Code QR pour campagne de marketing numérique, Code QR pour page d'inscription à un événement",
        h1: "URL vers code QR",
      },
      {
        name: "Document",
        slug: "document",
        description:
          "Simplifiez la gestion et le partage de documents avec notre générateur de codes QR gratuit, QRGateway. Créez instantanément des codes QR pour les fichiers téléchargés, permettant un accès facile au contenu par numérisation.",
        title: "Générateur de codes QR à partir de documents",
        keys: "Document vers code QR, Fichier vers code QR, Générateur de codes QR pour documents, Convertir des documents en codes QR, Générateur de codes QR gratuit pour les documents, Créateur de codes QR en ligne pour les fichiers, Partage de documents avec des codes QR, Code QR pour PDF, Word, Excel, etc., Créer des codes QR pour les documents, Gestion de documents avec des codes QR, Code QR pour le téléchargement de fichiers, Code QR pour l'accès aux documents, Codes QR dynamiques pour les documents, Code QR pour le suivi des documents",
        h1: "Document vers code QR",
      },
      {
        name: "Image",
        slug: "image",
        description:
          "QRGateway convertit des images en codes QR avec des fonctions avancées. Scannez pour accéder aux promotions, itinéraires, informations produits ou événements avec du texte et des images. Créez des codes QR personnalisés gratuitement avec QRGateway.",
        title: "Générateur de codes QR à partir d'images de la galerie",
        keys: "image en code QR, générateur de code QR pour image, convertir image en QR, code QR à partir d'une image, code QR à partir d'une photo, convertisseur d'image en code QR, outil image en QR, créateur de code QR pour images, générateur de code QR pour photos",
        h1: "Images en code QR",
      },
      {
        name: "Audio et Vidéo",
        slug: "multimedia",
        description:
          "Avec QRGateway, convertissez vos enregistrements audio ou vidéo en codes QR partageables. Distribuez votre contenu multimédia en permettant aux autres de scanner le code pour accéder à vos fichiers. Le partage de médias n'a jamais été aussi facile avec la fonction de génération de codes audio et vidéo de QRGateway.",
        title: "Générateur de codes QR à partir de supports multimédias",
        keys: "générateur de code QR pour audio, créateur de code QR pour vidéo, convertir les médias en code QR, créateur de code QR audio, générateur de code QR pour vidéo, codes QR partageables pour audio et vidéo, partage de médias via des codes QR, codes QR pour fichiers audio et vidéo, distribution de médias avec des codes QR, partage de codes QR pour multimédia",
        h1: "Convertir des supports multimédias en code QR",
      },
      {
        name: "Business Card",
        slug: "vcard",
        description:
          "Utilisez notre générateur de carte de visite rapide et gratuit pour créer des cartes personnelles ou professionnelles. Profitez d'un partage facile, de statistiques de visiteurs, de numérotation de contacts et d'ajout par lots. Développez votre entreprise et connectez-vous avec des clients potentiels dès aujourd'hui",
        title: "Créer des QR codes de carte de visite",
        keys: "QR codes de carte de visite,Générateur de codes QR de carte de visite,QR code de carte de visite personnelle,QR code de carte de visite d'entreprise,QR code de carte de visite numérique,QR code de carte de visite à numérisation pour sauvegarde,QR code de partage de contact,QR code de statistiques de visiteurs,QR code d'ajout par lots,QR code de carnet d'adresses",
        h1: "Créez votre carte de visite",
      },
      {
        name: "Carte",
        slug: "map",
        description:
          "Créez des codes QR pour n'importe quel emplacement Google Maps avec notre générateur gratuit. Partagez vos endroits préférés avec des amis, des clients ou à des fins marketing. Il suffit d'entrer l'adresse, de personnaliser le design et de télécharger le code QR.",
        title: "Générateur de codes QR pour Google Maps",
        keys: "Code QR Google Maps,Code QR d'emplacement de carte, Générateur de codes QR pour Google Maps,Intégrer Google Maps dans un code QR,QR code pour l'emplacement d'entreprise,Code QR Google Maps adapté aux mobiles,Code QR GPS,Code QR de partage de localisation,Code QR d'itinéraire de voyage,QR code pour la navigation",
        h1: "Google Maps à Code QR",
      },
      {
        name: "Événement",
        slug: "event",
        description:
          "Rehaussez votre expérience événementielle grâce aux codes QR d'événement",
        title: "Créer des Codes QR pour les Événements",
        keys: "Code QR d'événement, Code QR pour les événements, Simplifier la Gestion d'Événements, Solution de Check-in pour les Événements",
        h1: "Code QR d'Événement",
      },
      {
        name: "Wifi",
        slug: "wifi",
        description:
          "Simplifiez le processus de partage d'informations Wi-Fi avec ce générateur de code QR convivial.",
        title: "Créer des Codes QR pour le Wifi",
        keys: "Code QR Wi-Fi, Générateur de code QR, informations réseau, Accès Wi-Fi, connexion sans fil, Scanner de code QR, Partage Wi-Fi, sécurité réseau, chiffrement, connectivité facile.",
        h1: "Code QR Wifi",
      },
      {
        name: "Email",
        slug: "email",
        description:
          "Améliorez la commodité et simplifiez le partage d'e-mails avec cet efficace générateur de code QR",
        title: "Créer des Codes QR pour les E-mails",
        keys: "Code QR d'e-mail, Générateur de code QR, partage de contacts, adresse e-mail",
        h1: "Code QR Email",
      },
      {
        name: "SMS",
        slug: "sms",
        description:
          "Simplifiez la communication et accélérez la livraison des messages avec ce générateur de code QR convivial.",
        title: "Créer des Codes QR pour les SMS",
        keys: "Code QR SMS, Générateur de code QR, partage de messages, contenu SMS",
        h1: "Code QR SMS",
      },
      {
        name: "Texte",
        slug: "text",
        description:
          "Générez facilement des codes QR à partir de texte brut avec notre outil intuitif.",
        title: "Texte vers QR Code",
        keys: "Générateur de QR code, Créer des QR codes, Créateur de QR code gratuit, Générateur de texte vers QR code, Convertir du texte en QR code, Outil gratuit de texte vers QR code, Créateur de QR code, QR codes dynamiques, QR codes statiques",
        current: true,
        h1: "Texte vers QR Code",
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        name: "Widget",
        slug: "",
        description:
          "Personalisieren Sie Ihre QR-Codes ganz einfach durch das Hinzufügen von Logos, sodass Ihre Scans nicht nur funktional, sondern auch optisch ansprechend sind.",
        title: "QR Gateway - Kostenloser SVG QR Code Generator mit Logo",
        keys: "QR-Code-Generator, QR-Codes erstellen, Kostenloser QR-Code-Hersteller, Text in QR-Code-Generator konvertieren, Text in QR-Code umwandeln, Kostenloses Text-in-QR-Code-Tool, QR-Code-Ersteller, Dynamische QR-Codes, Statische QR-Codes",
        current: true,
        h1: "Der fortschrittlichste QR-Code-Generator mit Logo online",
      },
      {
        name: "Text",
        slug: "text",
        description:
          "Generieren Sie mühelos QR-Codes aus einfachem Text mit unserem intuitiven Tool.",
        title: "Text zu QR-Code",
        keys: "QR-Code-Generator, QR-Codes erstellen, Kostenloser QR-Code-Macher, Text-zu-QR-Code-Generator, Text in QR-Code umwandeln, Kostenloses Text-zu-QR-Code-Tool, QR-Code-Ersteller, Dynamische QR-Codes, Statische QR-Codes",
        current: true,
        h1: "Text zu QR-Code",
      },
      {
        name: "URL",
        slug: "url",
        description:
          "Unser kostenloser QR-Code-Generator erstellt sowohl statische als auch dynamische Codes und ermöglicht es Ihnen, die Ziel-URL jederzeit zu ändern.",
        title: "URL zu QR-Code-Generator",
        keys: "URL zu QR-Code, QR-Code aus URL generieren, QR-Code für Website, Website-QR-Code-Generator, Kostenloser URL-zu-QR-Code-Konverter, Online-QR-Code-Ersteller, Dynamischer QR-Code für Website, QR-Code für Website-URL, Benutzerdefinierter Website-QR-Code, QR-Code für Landing Page, QR-Code für Blog-Beitrag, QR-Code für Online-Shop, QR-Code für Social-Media-Profil, QR-Code für digitale Marketingkampagne, QR-Code für Event-Registrierungsseite",
        h1: "URL zu QR-Code",
      },
      {
        name: "Dokument",
        slug: "document",
        description:
          "Vereinfachen Sie das Dokumentenmanagement und -freigabe mit unserem kostenlosen QR-Code-Generator, QRGateway. Erstellen Sie sofort QR-Codes für hochgeladene Dateien, um einen einfachen Zugriff auf den Inhalt durch Scannen zu ermöglichen.",
        title: "Dokument zu QR-Code-Generator",
        keys: "Dokument zu QR-Code, Datei zu QR-Code, QR-Code-Generator für Dokumente, Dokumente in QR-Codes umwandeln, Kostenloser QR-Code-Generator für Dokumente, Online-QR-Code-Ersteller für Dateien, Dokumentenfreigabe mit QR-Codes, QR-Code für PDF, Word, Excel, usw., QR-Codes für Dokumente erstellen, Dokumentenmanagement mit QR-Codes, QR-Code zum Herunterladen von Dateien, QR-Code für den Zugriff auf Dokumente, Dynamische QR-Codes für Dokumente, QR-Code für die Dokumentenverfolgung",
        h1: "Dokument zu QR-Code",
      },
      {
        name: "Bild",
        slug: "image",
        description:
          "QRGateway konvertiert Bilder in QR-Codes mit erweiterten Funktionen. Scannen Sie für den Zugriff auf Angebote, Reiserouten, Produktinformationen oder Ereignisse mit Text und Bildern. Erstellen Sie mit QRGateway kostenlos benutzerdefinierte QR-Codes.",
        title: "Galeriebilder in QR-Code-Generator",
        keys: "Bild in QR-Code, QR-Code-Generator für Bilder, Bild in QR-Code konvertieren, QR-Code aus Bild, QR-Code aus Foto, Bild-in-Code-Konverter, Bild-in-QR-Tool, QR-Code-Ersteller für Bilder, QR-Code-Macher für Fotos",
        h1: "Bilder in QR-Code",
      },
      {
        name: "Audio und Video",
        slug: "multimedia",
        description:
          "Mit QRGateway konvertieren Sie Ihre Audio- oder Videoaufnahmen in freigabefähige QR-Codes. Verteilen Sie Ihre Medieninhalte, indem Sie anderen das Scannen des Codes ermöglichen, um auf Ihre Dateien zuzugreifen. Das Teilen von Medien war noch nie so einfach wie mit der Audio- und Video-Code-Generierungsfunktion von QRGateway.",
        title: "Multimedia in QR-Code-Generator",
        keys: "QR-Code-Generator für Audio, QR-Code-Ersteller für Video, Konvertierung von Medien in QR-Code, Audio-QR-Code-Macher, Video-QR-Code-Generator, freigabefähige QR-Codes für Audio und Video, Medienfreigabe über QR-Codes, QR-Codes für Audio- und Video-Dateien, Verteilung von Medien mit QR-Codes, QR-Code-Freigabe für Multimedia",
        h1: "Multimedia in QR-Code konvertieren",
      },
      {
        name: "Visitenkarte",
        slug: "vcard",
        description:
          "Utilisez notre générateur de cartes de visite rapide et gratuit pour créer des cartes personnelles ou professionnelles. Profitez d'un partage facile, de statistiques de visiteurs, de numérotation de contact et d'ajout en lot. Développez votre entreprise et connectez-vous avec des clients potentiels dès aujourd'hui.",
        title: "Créer des codes QR de cartes de visite",
        keys: "Codes QR de cartes de visite, générateur de codes QR pour cartes de visite, code QR de carte de visite personnelle, code QR de carte de visite d'entreprise, code QR de carte de visite numérique, code QR de carte de visite scan-to-save, code QR de partage de contact, code QR de statistiques de visiteurs, code QR d'ajout en lot, code QR de carnet d'adresses",
        h1: "Créez votre VCard",
      },
      {
        name: "Map",
        slug: "map",
        description:
          "Créez des codes QR pour n'importe quel emplacement de Google Maps avec notre générateur gratuit. Partagez vos endroits préférés avec des amis, des clients ou à des fins marketing. Il suffit d'entrer l'adresse, de personnaliser le design et de télécharger le code QR.",
        title: "Générateur de codes QR de Google Maps",
        keys: "Code QR de Google Map, code QR d'emplacement sur la carte, générateur de codes QR pour Google Maps, intégrer Google Maps dans un code QR, code QR pour l'emplacement d'entreprise, code QR de Google Maps compatible avec les mobiles, code QR de GPS, code QR de partage de localisation, code QR d'itinéraire de voyage, code QR de navigation",
        h1: "Google Maps vers code QR",
      },
      {
        name: "Veranstaltung",
        slug: "event",
        description:
          "Verbessern Sie Ihr Veranstaltungserlebnis mit Event-QR-Codes",
        title: "QR-Codes für Veranstaltungen erstellen",
        keys: "Event-QR-Code, QR-Code für Veranstaltungen, Vereinfachte Veranstaltungsverwaltung, Lösung für Event-Einchecken",
        h1: "Event-QR-Code",
      },
      {
        name: "Wifi",
        slug: "wifi",
        description:
          "Vereinfachen Sie den Prozess der Weitergabe von Wi-Fi-Informationen mit diesem benutzerfreundlichen QR-Code-Generator.",
        title: "QR-Codes für Wi-Fi erstellen",
        keys: "Wi-Fi QR-Code, QR-Code-Generator, Netzwerkzugangsdaten, Wi-Fi-Zugang, Drahtlose Verbindung, QR-Code-Scanner, Wi-Fi-Teilen, Netzwerksicherheit, Verschlüsselung, einfache Konnektivität.",
        h1: "Wi-Fi QR-Code",
      },
      {
        name: "E-Mail",
        slug: "email",
        description:
          "Erhöhen Sie die Bequemlichkeit und optimieren Sie das Teilen von E-Mails mit diesem effizienten QR-Code-Generator",
        title: "QR-Codes für E-Mails erstellen",
        keys: "E-Mail QR-Code, QR-Code-Generator, Kontakt teilen, E-Mail-Adresse",
        h1: "E-Mail QR-Code",
      },
      {
        name: "SMS",
        slug: "sms",
        description:
          "Vereinfachen Sie die Kommunikation und beschleunigen Sie die Nachrichtenzustellung mit diesem benutzerfreundlichen QR-Code-Generator.",
        title: "QR-Codes für SMS erstellen",
        keys: "SMS QR-Code, QR-Code-Generator, Nachricht teilen, SMS-Inhalt",
        h1: "SMS QR-Code",
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        name: "Widget",
        slug: "",
        description:
          "Personalizza facilmente i tuoi codici QR aggiungendo loghi, rendendo le tue scansioni non solo funzionali ma visivamente accattivanti.",
        title: "QR Gateway - Generatore di codici QR gratuiti in formato SVG con logo",
        keys: "Generatore di codici QR, Crea codici QR, Creatore di codici QR gratuiti, Generatore di codici QR da testo, Convertitore di testo in codice QR, Strumento di testo gratuito per codice QR, Creatore di codici QR dinamici, Codici QR statici",
        current: true,
        h1: "Il generatore di codici QR più avanzato con Logo online",
      },
      {
        name: "Testo",
        slug: "text",
        description:
          "Genera facilmente codici QR da testo semplice con il nostro intuitivo strumento.",
        title: "Testo a Codice QR",
        keys: "Generatore di codici QR, Crea codici QR, Creatore gratuito di codici QR, Generatore di testo a codice QR, Converti testo in codice QR, Strumento gratuito di testo a codice QR, Creatore di codici QR, Codici QR dinamici, Codici QR statici",
        current: true,
        h1: "Testo a Codice QR",
      },
      {
        name: "URL",
        slug: "url",
        description:
          "Il nostro generatore di codici QR gratuito crea codici sia statici che dinamici, consentendoti di modificare l'URL di destinazione in qualsiasi momento.",
        title: "Generatore di codici QR per URL",
        keys: "URL in codice QR, Genera codice QR dall'URL, Codice QR per il sito web, Generatore di codici QR per sito web, Convertitore gratuito di URL in codice QR, Creatore di codici QR online, Codice QR dinamico per sito web, Codice QR per URL del sito web, Codice QR personalizzato per il sito web, Codice QR per pagina di destinazione, Codice QR per post del blog, Codice QR per negozio online, Codice QR per profilo dei social media, Codice QR per campagna di marketing digitale, Codice QR per pagina di registrazione evento,",
        h1: "URL in Codice QR",
      },
      {
        name: "Document",
        slug: "document",
        description:
          "Ottimizza la gestione e la condivisione dei documenti con il nostro generatore di codici QR gratuito, QRGateway. Crea istantaneamente codici QR per i file caricati, consentendo un facile accesso al contenuto tramite scansione.",
        title: "Generatore di codici QR per documenti",
        keys: "Documenti in codice QR, File in codice QR, Generatore di codici QR per documenti, Convertitore di documenti in codice QR, Generatore di codici QR per documenti gratuito, Creatore di codici QR online per i file, Condivisione di documenti con codici QR, Codice QR per PDF, Word, Excel, ecc., Crea codici QR per documenti, Gestione dei documenti con codici QR, Codice QR per il download di file, Codice QR per l'accesso ai documenti, Codici QR dinamici per documenti, Codice QR per il tracciamento dei documenti",
        h1: "Documenti in Codice QR",
      },
      {
        name: "Immagine",
        slug: "image",
        description:
          "QRGateway converte le immagini in codici QR con funzioni avanzate. Scansiona per accedere a promozioni, itinerari, informazioni sui prodotti o eventi con testo e immagini. Crea codici QR personalizzati gratuitamente con QRGateway.",
        title: "Generatore di codici QR per immagini della galleria",
        keys: "immagine in codice QR, generatore di codici QR per immagini, converti immagine in QR, codice QR da immagine, codice QR da foto, convertitore di immagine in codice, strumento di conversione immagine in QR, creatore di codici QR per immagini, creatore di codici QR per foto",
        h1: "Immagine in codice QR",
      },
      {
        name: "Audio e Video",
        slug: "multimedia",
        description:
          "Con QRGateway, converte le tue registrazioni audio o video in codici QR condivisibili. Distribuisci i tuoi contenuti multimediali consentendo ad altri di scansionare il codice per accedere ai tuoi file. La condivisione di media non è mai stata così facile grazie alla funzione di generazione di codici audio e video di QRGateway.",
        title: "Generatore di codici QR per multimedia",
        keys: "generatore di codici QR per audio, creatore di codici QR per video, converti media in QR, creatore di codici QR per audio, generatore di codici QR per video, codici QR condivisibili per audio e video, condivisione di media attraverso codici QR, codici QR per file audio e video, distribuzione di media con codici QR, condivisione di codici QR per multimedia",
        h1: "Converti multimedia in codice QR",
      },
      {
        name: "Biglietto da visita",
        slug: "vcard",
        description:
          "Usa il nostro rapido e gratuito generatore di biglietti da visita per creare carte personali o aziendali. Goditi la condivisione facile, le statistiche dei visitatori, la chiamata di contatto e l'aggiunta di batch. Espandi la tua attività e connettiti con potenziali clienti oggi stesso.",
        title: "Crea codici QR per biglietti da visita",
        keys: "Codici QR per biglietti da visita, generatore di codici QR per biglietti da visita, Codice QR per biglietto da visita personale, Codice QR per biglietto da visita aziendale, Codice QR per biglietto da visita digitale, Codice QR per biglietto da visita scan-to-save, Codice QR per la condivisione dei contatti, Codice QR per le statistiche dei visitatori, Codice QR per l'aggiunta di batch, Codice QR per rubrica",
        h1: "Crea il tuo Biglietto da visita",
      },
      {
        name: "Mappa",
        slug: "map",
        description:
          "Crea codici QR per qualsiasi posizione di Google Maps con il nostro generatore gratuito. Condividi i tuoi luoghi preferiti con amici, clienti o per scopi di marketing. Basta inserire l'indirizzo, personalizzare il design e scaricare il codice QR.",
        title: "Generatore di codici QR per Google Maps",
        keys: "Codice QR di Google Map, Codice QR della posizione sulla mappa, generatore di codici QR per Google Maps, incorpora Google Maps in un codice QR, codice QR per la posizione aziendale, codice QR di Google Maps mobile-friendly, codice QR del GPS, codice QR per la condivisione della posizione, codice QR per l'itinerario di viaggio, codice QR per la navigazione",
        h1: "Google Maps in codice QR",
      },
      {
        name: "Evento",
        slug: "event",
        description:
          "Eleva la tua esperienza di evento attraverso i codici QR per eventi",
        title: "Crea codici QR per eventi",
        keys: "Codice QR per eventi, Codice QR per eventi, Ottimizza la Gestione degli Eventi, Soluzione di Check-in per Eventi",
        h1: "Codice QR per Evento",
      },
      {
        name: "Wifi",
        slug: "wifi",
        description:
          "Semplifica il processo di condivisione delle informazioni Wi-Fi con questo generatore di codici QR user-friendly.",
        title: "Crea codici QR per il Wi-Fi",
        keys: "Codice QR Wi-Fi, Generatore di codici QR, Credenziali di rete, Accesso Wi-Fi, Connessione wireless, Lettore di codici QR, Condivisione Wi-Fi, Sicurezza di rete, Crittografia, Connessione facile.",
        h1: "Codice QR Wi-Fi",
      },
      {
        name: "Email",
        slug: "email",
        description:
          "Migliora la comodità e semplifica la condivisione delle email con questo efficiente generatore di codici QR",
        title: "Crea codici QR per le Email",
        keys: "Codice QR per email, Generatore di codici QR, Condivisione contatti, Indirizzo email",
        h1: "Codice QR Email",
      },
      {
        name: "SMS",
        slug: "sms",
        description:
          "Semplifica la comunicazione e accelera la consegna dei messaggi con questo generatore di codici QR user-friendly.",
        title: "Crea codici QR per gli SMS",
        keys: "Codice QR per SMS, Generatore di codici QR, Condivisione messaggi, Contenuto SMS",
        h1: "Codice QR SMS",
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        name: "Widget",
        slug: "",
        description:
          "Personalice sus códigos QR fácilmente agregando logotipos, haciendo que sus escaneos no solo sean funcionales sino también visualmente atractivos.",
        title: "QR Gateway - Generador de códigos QR SVG gratuitos con logotipo",
        keys: "Generador de códigos QR,Crear códigos QR,Generador de códigos QR gratis,Generador de códigos QR a partir de texto,Convertir texto a códigos QR,Herramienta de texto a código QR gratis,Creador de códigos QR,Códigos QR dinámicos,Códigos QR estáticos",
        current: true,
        h1: "El generador de código QR más avanzado con logotipo en línea",
      },
      {
        name: "Texto",
        slug: "text",
        description:
          "Genera fácilmente códigos QR a partir de texto simple con nuestra intuitiva herramienta.",
        title: "Texto a Código QR",
        keys: "Generador de códigos QR, Crear códigos QR, Creador gratuito de códigos QR, Generador de texto a código QR, Convertir texto a código QR, Herramienta gratuita de texto a código QR, Creador de códigos QR, Códigos QR dinámicos, Códigos QR estáticos",
        current: true,
        h1: "Texto a Código QR",
      },
      
      {
        name: "URL",
        slug: "url",
        description:
          "Nuestro generador de códigos QR gratuito crea códigos tanto estáticos como dinámicos, lo que te permite cambiar la URL de destino en cualquier momento.",
        title: "Generador de códigos QR a partir de URL",
        keys: "Código QR para URL,Generar código QR a partir de URL,Código QR para sitio web,Generador de códigos QR para sitio web,Convertidor gratuito de URL a código QR,Creador de códigos QR en línea,Código QR dinámico para sitio web,Código QR para URL de sitio web,Código QR personalizado de sitio web,Código QR para página de destino,Código QR para publicación de blog,Código QR para tienda en línea,Código QR para perfil de redes sociales,Código QR para campañas de marketing digital,Código QR para página de registro de eventos,",
        h1: "URL a código QR",
      },
      {
        name: "Document",
        slug: "document",
        description:
          "Optimiza la gestión y el intercambio de documentos con nuestro generador de códigos QR gratuito, QRGateway. Crea códigos QR al instante para archivos subidos, lo que permite un fácil acceso al contenido a través de escaneo.",
        title: "Generador de códigos QR para documentos",
        keys: "Código QR para documentos,Archivo a código QR,Generador de códigos QR para documentos,Convertir documentos a códigos QR,Generador de códigos QR gratis para documentos,Creador de códigos QR en línea para archivos,Compartir documentos con códigos QR,Código QR para PDF, Word, Excel, etc.,Crear códigos QR para documentos,Gestión de documentos con códigos QR,Código QR para descarga de archivos,Código QR para acceso a documentos,Códigos QR dinámicos para documentos,Código QR para seguimiento de documentos",
        h1: "Documento a código QR",
      },
      {
        name: "Imagen",
        slug: "image",
        description:
          "QRGateway convierte imágenes en códigos QR con funciones avanzadas. Escanéalo para acceder a promociones, itinerarios, información de productos o eventos con texto e imágenes. Crea códigos QR personalizados gratis con QRGateway.",
        title: "Generador de códigos QR para imágenes de galería",
        keys: "imagen a código QR, generador de código QR para imagen, convertir imagen a QR, código QR de imagen, código QR de foto, convertidor de imagen a código QR, herramienta de imagen a QR, creador de código QR para imágenes, creador de código QR para fotos",
        h1: "Imagen a código QR",
      },
      {
        name: "Audio y Video",
        slug: "multimedia",
        description:
          "Con QRGateway, convierte tus grabaciones de audio o video en códigos QR compartibles. Distribuye tu contenido de medios permitiendo que otros escaneen el código para acceder a tus archivos. Compartir medios nunca ha sido tan fácil con la función de generación de código de audio y video de QRGateway.",
        title: "Generador de códigos QR para multimedia",
        keys: "generador de código QR para audio, creador de código QR para video, convertir multimedia a QR, creador de código QR para audio, generador de código QR para video, códigos QR compartibles para audio y video, compartir medios a través de códigos QR, códigos QR para archivos de audio y video, distribuir medios con códigos QR, compartir códigos QR para multimedia",
        h1: "Convertir multimedia a código QR",
      },
      {
        name: "Tarjeta de visita",
        slug: "vcard",
        description:
          "Utiliza nuestro generador rápido y gratuito de tarjetas de visita para crear tarjetas personales o corporativas. Disfruta de un fácil intercambio, estadísticas de visitantes, marcación de contactos y adición por lotes. Amplía tu negocio y conecta con potenciales clientes hoy mismo.",
        title: "Crea códigos QR para tarjetas de visita",
        keys: "Códigos QR para tarjetas de visita, Generador de códigos QR para tarjetas de visita, Código QR para tarjetas de visita personales, Código QR para tarjetas de visita corporativas, Código QR de tarjeta de visita digital, Código QR para guardar tarjeta de visita, Código QR para compartir contactos, Código QR de estadísticas de visitantes, Código QR para añadir por lotes, Código QR para libro de direcciones",
        h1: "Crea tu vCard",
      },
      {
        name: "Map",
        slug: "map",
        description:
          "Crea códigos QR para cualquier ubicación de Google Maps con nuestro generador gratuito. Comparte tus lugares favoritos con amigos, clientes o para fines de marketing. Simplemente ingresa la dirección, personaliza el diseño y descarga el código QR.",
        title: "Generador de códigos QR para Google Maps",
        keys: "Código QR de Google Maps, Código QR de ubicación en mapa, Generador de códigos QR para Google Maps, Incrustar Google Maps en código QR, Código QR para ubicación comercial, Código QR de Google Maps para móviles, Código QR de GPS, Código QR para compartir ubicación, Código QR para itinerario de viaje, Código QR para navegación",
        h1: "Google Maps a código QR",
      },
      {
        name: "Evento",
        slug: "event",
        description:
          "Mejora tu experiencia en eventos a través de códigos QR para eventos",
        title: "Crear códigos QR para eventos",
        keys: "Código QR para eventos, Código QR para eventos, Simplificar la Gestión de Eventos, Solución de Registro de Eventos",
        h1: "Código QR para Evento",
      },
      {
        name: "Wifi",
        slug: "wifi",
        description:
          "Simplifica el proceso de compartir información de Wi-Fi con este generador de códigos QR fácil de usar.",
        title: "Crear códigos QR para Wi-Fi",
        keys: "Código QR Wi-Fi, Generador de códigos QR, Credenciales de red, Acceso Wi-Fi, Conexión inalámbrica, Escáner de códigos QR, Compartir Wi-Fi, Seguridad de red, Encriptación, Conexión sencilla.",
        h1: "Código QR Wi-Fi",
      },
      {
        name: "Email",
        slug: "email",
        description:
          "Mejora la conveniencia y agiliza el intercambio de correos electrónicos con este eficiente generador de códigos QR",
        title: "Crear códigos QR para correos electrónicos",
        keys: "Código QR para correo electrónico, Generador de códigos QR, Compartir contactos, Dirección de correo electrónico",
        h1: "Código QR de Correo Electrónico",
      },
      {
        name: "SMS",
        slug: "sms",
        description:
          "Simplifica la comunicación y agiliza la entrega de mensajes con este generador de códigos QR fácil de usar.",
        title: "Crear códigos QR para mensajes SMS",
        keys: "Código QR para SMS, Generador de códigos QR, Compartir mensajes, Contenido de SMS",
        h1: "Código QR de SMS",
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        name: "Widget",
        slug: "",
        description:
          "Personalize seus códigos QR facilmente adicionando logotipos, tornando suas digitalizações não apenas funcionais, mas também visualmente atraentes.",
        title: "QR Gateway - Gerador de Códigos QR SVG Gratuito com Logotipo",
        keys: "Gerador de código QR, Criar códigos QR, Criador de código QR gratuito, Gerador de QR de texto, Converter texto em código QR, Ferramenta gratuita de texto para QR, Criador de código QR dinâmico, Códigos QR estáticos e dinâmicos",
        current: true,
        h1: "O gerador de código QR mais avançado com logotipo online",
      },
      {
        name: "Texto",
        slug: "text",
        description:
          "Gere facilmente códigos QR a partir de texto simples com a nossa ferramenta intuitiva.",
        title: "Texto para Código QR",
        keys: "Gerador de códigos QR, Criar códigos QR, Criador gratuito de códigos QR, Gerador de texto para código QR, Converter texto para código QR, Ferramenta gratuita de texto para código QR, Criador de códigos QR, Códigos QR dinâmicos, Códigos QR estáticos",
        current: true,
        h1: "Texto para Código QR",
      },
      
      {
        name: "URL",
        slug: "url",
        description:
          "Nosso gerador de código QR gratuito cria códigos estáticos e dinâmicos, permitindo que você altere o URL de destino a qualquer momento.",
        title: "Gerador de Código QR de URL",
        keys: "URL para código QR, Gerar código QR a partir do URL, Código QR para website, Gerador de código QR para website, Conversor gratuito de URL para QR, Criador de código QR online, Código QR dinâmico para website, Código QR para URL de website, Código QR personalizado para website, Código QR para página de registro de eventos, Código QR para postagem de blog, Código QR para loja online, Código QR para perfil de mídia social, Código QR para campanha de marketing digital, Código QR para download de arquivo",
        h1: "URL para Código QR",
      },
      {
        name: "Documento",
        slug: "document",
        description:
          "Simplifique a gestão e o compartilhamento de documentos com o nosso gerador de código QR gratuito, QRGateway. Crie instantaneamente códigos QR para arquivos enviados, permitindo fácil acesso ao conteúdo através da leitura do código.",
        title: "Gerador de Código QR de Documento",
        keys: "Documento para código QR, Arquivo para código QR, Gerador de código QR para documentos, Converter documentos em código QR, Gerador de código QR gratuito para documentos, Criador de código QR online para arquivos, Compartilhamento de documentos com QR codes, Código QR para PDF, Word, Excel, etc., Criar códigos QR para documentos, Gestão de documentos com códigos QR, Código QR para download de arquivo, Código QR para acesso a documentos, Códigos QR dinâmicos para documentos, Código QR para rastreamento de documentos",
        h1: "Documento para Código QR",
      },
      {
        name: "Imagem",
        slug: "image",
        description:
          "QRGateway converte imagens em códigos QR com funções avançadas. Escaneie para ter acesso a promoções, itinerários, informações de produtos ou eventos com texto e imagens. Crie códigos QR personalizados gratuitamente com o QRGateway.",
        title: "Gerador de códigos QR para imagens de galeria",
        keys: "imagem para código QR, gerador de código QR para imagem, converter imagem em QR, código QR de imagem, código QR de foto, conversor de imagem para código QR, ferramenta de imagem para QR, criador de código QR para imagens, criador de código QR para fotos",
        h1: "Imagens para código QR",
      },
      {
        name: "Áudio e Vídeo",
        slug: "multimedia",
        description:
          "Com o QRGateway, converta suas gravações de áudio ou vídeo em códigos QR compartilháveis. Distribua seu conteúdo de mídia permitindo que outros escaneiem o código para acessar seus arquivos. Compartilhar mídia nunca foi tão fácil com a função de geração de código de áudio e vídeo do QRGateway.",
        title: "Gerador de códigos QR para multimídia",
        keys: "gerador de código QR para áudio, criador de código QR para vídeo, converter mídia em QR, criador de código QR para áudio, gerador de código QR para vídeo, códigos QR compartilháveis para áudio e vídeo, compartilhamento de mídia por meio de códigos QR, códigos QR para arquivos de áudio e vídeo, distribuir mídia com códigos QR, compartilhar códigos QR para multimídia",
        h1: "Converter multimídia em código QR",
      },
      {
        name: "Cartão de visitas",
        slug: "vcard",
        description:
          "Use nosso gerador de cartões de visita rápido e gratuito para criar cartões pessoais ou corporativos. Aproveite o compartilhamento fácil, estatísticas de visitantes, discagem de contato e adição em lote. Expanda seu negócio e conecte-se com potenciais clientes hoje mesmo",
        title: "Crie códigos QR para cartões de visita",
        keys: "Códigos QR para cartões de visita, Gerador de código QR para cartões de visita, Cartão de visita pessoal com código QR, Cartão de visita corporativo com código QR, Cartão de visita digital com código QR, Código QR para salvar cartão de visita, Compartilhamento de contato com código QR, Estatísticas de visitantes com código QR, Adição em lote com código QR, Agenda de endereços com código QR",
        h1: "Crie seu VCard",
      },
      {
        name: "Mapa",
        slug: "map",
        description:
          "Crie códigos QR para qualquer localização do Google Maps com nosso gerador gratuito. Compartilhe seus lugares favoritos com amigos, clientes ou para fins de marketing. Basta inserir o endereço, personalizar o design e baixar o código QR.",
        title: "Gerador de códigos QR para Google Maps",
        keys: "Código QR para Google Maps, Código QR para localização no mapa, Gerador de código QR para Google Maps, Incorporar Google Maps em um código QR, Código QR para localização empresarial, Código QR para Google Maps compatível com dispositivos móveis, Código QR para GPS, Código QR para compartilhamento de localização, Código QR para itinerário de viagem, Código QR para navegação",
        h1: "Google Maps para código QR",
      },
      {
        name: "Evento",
        slug: "event",
        description:
          "Eleve sua experiência de evento por meio de códigos QR de evento",
        title: "Criar Códigos QR para Eventos",
        keys: "Código QR de evento, Código QR para eventos, Simplificar a Gestão de Eventos, Solução de Check-in para Eventos",
        h1: "Código QR de Evento",
      },
      {
        name: "Wifi",
        slug: "wifi",
        description:
          "Simplifique o processo de compartilhamento de informações de Wi-Fi com este gerador de códigos QR de fácil utilização.",
        title: "Criar Códigos QR para Wi-Fi",
        keys: "Código QR de Wi-Fi, Gerador de códigos QR, Credenciais de rede, Acesso Wi-Fi, Conexão sem fio, Leitor de códigos QR, Compartilhamento de Wi-Fi, Segurança de rede, Criptografia, Conectividade fácil.",
        h1: "Código QR de Wi-Fi",
      },
      {
        name: "Email",
        slug: "email",
        description:
          "Aprimore a conveniência e agilize o compartilhamento de e-mails com este eficiente gerador de códigos QR",
        title: "Criar Códigos QR para E-mails",
        keys: "Código QR de e-mail, Gerador de códigos QR, Compartilhamento de contatos, Endereço de e-mail",
        h1: "Código QR de E-mail",
      },
      {
        name: "SMS",
        slug: "sms",
        description:
          "Simplifique a comunicação e acelere a entrega de mensagens com este gerador de códigos QR de fácil utilização.",
        title: "Criar Códigos QR para SMS",
        keys: "Código QR de SMS, Gerador de códigos QR, Compartilhamento de mensagens, Conteúdo de SMS",
        h1: "Código QR de SMS",
      },
    ],
  },
  {
    locale: "nl",
    data: [
      {
        name: "Widget",
        slug: "",
        description:
          "QRGateway vereenvoudigt QR-technologie voor praktisch gebruik. Combineer functies zoals weergave, formulieren, batchverwerking, statistieken en opmaak om efficiënte QR-codes gratis te maken. Hergebruik succesvolle gevallen om zakelijke problemen op te lossen.",
        title: "Maak QR-codes gratis",
        keys: "QR-codegenerator, QR-codes maken, Gratis QR-code-maker, Tekst naar QR-codegenerator, Tekst converteren naar QR-code, Gratis tekst naar QR-code-tool, QR-code-creator, Dynamische QR-codes, Statische QR-codes",
        current: true,
        h1: "QR-codegenerator",
      },
      {
        name: "Tekst",
        slug: "text",
        description:
          "Genereer moeiteloos QR-codes van eenvoudige tekst met onze intuïtieve tool.",
        title: "Tekst naar QR-code",
        keys: "QR-code generator, Maak QR-codes, Gratis QR-code maker, Tekst naar QR-code generator, Zet tekst om naar QR-code, Gratis tekst naar QR-code tool, QR-code maker, Dynamische QR-codes, Statische QR-codes",
        current: true,
        h1: "Tekst naar QR-code",
      },

      {
        name: "URL",
        slug: "url",
        description:
          "Onze gratis QR-codegenerator maakt zowel statische als dynamische codes, waarmee u op elk moment de bestemmings-URL kunt wijzigen.",
        title: "URL naar QR-codegenerator",
        keys: "URL naar QR-code, QR-code genereren vanuit URL, QR-code voor website, Website QR-codegenerator, Gratis URL naar QR-code-converter, Online QR-codecreator, Dynamische QR-code voor website, QR-code voor website-URL, Aangepaste website QR-code, QR-code voor landingspagina, QR-code voor blogpost, QR-code voor online winkel, QR-code voor profiel op sociale media, QR-code voor digitale marketingcampagne, QR-code voor registratiepagina van evenementen,",
        h1: "URL naar QR-code",
      },
      {
        name: "Document",
        slug: "document",
        description:
          "Vereenvoudig documentbeheer en delen met onze gratis QR-codegenerator, QRGateway. Maak onmiddellijk QR-codes voor geüploade bestanden, zodat de inhoud gemakkelijk toegankelijk is door te scannen.",
        title: "Document naar QR-codegenerator",
        keys: "Document naar QR-code, Bestand naar QR-code, QR-codegenerator voor documenten, Documenten converteren naar QR-codes, Gratis QR-codegenerator voor documenten, Online QR-codecreator voor bestanden, Documenten delen met QR-codes, QR-code voor PDF, Word, Excel, enz., QR-codes maken voor documenten, Documentbeheer met QR-codes, QR-code voor bestandsdownload, QR-code voor documenttoegang, Dynamische QR-codes voor documenten, QR-code voor documenttracking",
        h1: "Document naar QR-code",
      },
      {
        name: "Imagem",
        slug: "image",
        description:
          "QRGateway converte imagens em códigos QR com funções avançadas. Escaneie para ter acesso a promoções, itinerários, informações de produtos ou eventos com texto e imagens. Crie códigos QR personalizados gratuitamente com o QRGateway.",
        title: "Gerador de códigos QR para imagens de galeria",
        keys: "imagem para código QR, gerador de código QR para imagem, converter imagem em QR, código QR de imagem, código QR de foto, conversor de imagem para código QR, ferramenta de imagem para QR, criador de código QR para imagens, criador de código QR para fotos",
        h1: "Imagens para código QR",
      },
      {
        name: "Áudio e Vídeo",
        slug: "multimedia",
        description:
          "Com o QRGateway, converta suas gravações de áudio ou vídeo em códigos QR compartilháveis. Distribua seu conteúdo de mídia permitindo que outros escaneiem o código para acessar seus arquivos. Compartilhar mídia nunca foi tão fácil com a função de geração de código de áudio e vídeo do QRGateway.",
        title: "Gerador de códigos QR para multimídia",
        keys: "gerador de código QR para áudio, criador de código QR para vídeo, converter mídia em QR, criador de código QR para áudio, gerador de código QR para vídeo, códigos QR compartilháveis para áudio e vídeo, compartilhamento de mídia por meio de códigos QR, códigos QR para arquivos de áudio e vídeo, distribuir mídia com códigos QR, compartilhar códigos QR para multimídia",
        h1: "Converter multimídia em código QR",
      },
      {
        name: "Visitekaartje",
        slug: "vcard",
        description:
          "Gebruik onze snelle en gratis visitekaartgenerator om persoonlijke of zakelijke kaartjes te maken. Geniet van gemakkelijk delen, bezoekerstatistieken, contacttoetsen en batch-toevoeging. Breid je bedrijf uit en maak vandaag nog verbinding met potentiële klanten.",
        title: "Maak QR-codes voor visitekaartjes",
        keys: "Visitekaart QR-codes, QR-codegenerator voor visitekaartjes, Persoonlijke visitekaart QR-code, Zakelijke visitekaart QR-code, Digitale visitekaart QR-code, Scan-to-save visitekaart QR-code, Contact delen QR-code, Bezoekerstatistieken QR-code, Batch-toevoeging QR-code, Adresboek QR-code",
        h1: "Maak uw VCard",
      },
      {
        name: "Map",
        slug: "map",
        description:
          "Maak QR-codes voor elke Google Maps-locatie met onze gratis generator. Deel uw favoriete plaatsen met vrienden, klanten of voor marketingdoeleinden. Voer gewoon het adres in, pas het ontwerp aan en download de QR-code.",
        title: "Google Maps naar QR-codegenerator",
        keys: "Google Map QR-code, Locatie QR-code, QR-codegenerator voor Google Maps, Google Maps insluiten in QR-code, QR-code voor zakelijke locatie, Mobielvriendelijke Google Maps QR-code, GPS QR-code, Locatie delen QR-code, Reisroute QR-code, QR-code voor navigatie",
        h1: "Google Maps naar QR-code",
      },
      {
        name: "Evenement",
        slug: "event",
        description:
          "Verbeter je evenementervaring met behulp van Event QR-codes",
        title: "QR-codes maken voor Evenementen",
        keys: "Evenement QR-code, QR-code voor Evenementen, Vereenvoudigd Evenementenbeheer, Oplossing voor Evenement Check-in",
        h1: "Evenement QR-code",
      },
      {
        name: "Wifi",
        slug: "wifi",
        description:
          "Vereenvoudig het proces van het delen van Wi-Fi informatie met deze gebruiksvriendelijke QR-code generator.",
        title: "QR-codes maken voor Wifi",
        keys: "Wi-Fi QR-code, QR-code generator, netwerkgegevens, Wi-Fi toegang, draadloze verbinding, QR-code scanner, Wi-Fi delen, netwerkbeveiliging, versleuteling, eenvoudige connectiviteit.",
        h1: "Wifi QR-code",
      },
      {
        name: "E-mail",
        slug: "email",
        description:
          "Verbeter het gemak en stroomlijn het delen van e-mail met deze efficiënte QR-code generator",
        title: "QR-codes maken voor E-mail",
        keys: "E-mail QR-code, QR-code generator, contact delen, e-mailadres",
        h1: "E-mail QR-code",
      },
      {
        name: "SMS",
        slug: "sms",
        description:
          "Vereenvoudig communicatie en versnel de levering van berichten met deze gebruiksvriendelijke QR-code generator.",
        title: "QR-codes maken voor SMS",
        keys: "SMS QR-code, QR-code generator, bericht delen, SMS inhoud",
        h1: "SMS QR-code",
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        name: "Widget",
        slug: "",
        description:
          "ロゴを追加することで QR コードを簡単にカスタマイズでき、スキャンが機能的であるだけでなく視覚的にも魅力的になります。",
        title: "QR Gateway - ロゴ付き無料SVG QRコードジェネレーター",
        keys: "QRコードジェネレーター、QRコード作成、無料QRコードメーカー、テキストからQRコードジェネレーター、テキストをQRコードに変換、無料テキストからQRコードツール、QRコード作成、動的QRコード、静的QRコード",
        current: true,
        h1: "QRコードジェネレーター",
      },
      {
        name: "テキスト",
        slug: "text",
        description:
          "直感的なツールを使用して簡単にプレーンテキストからQRコードを生成します。",
        title: "テキストからQRコード",
        keys: "QRコードジェネレータ、QRコード作成、無料QRコードメーカー、テキストからQRコードジェネレータ、テキストをQRコードに変換、無料のテキストからQRコードツール、QRコードクリエーター、ダイナミックQRコード、静的QRコード",
        current: true,
        h1: "テキストからQRコード",
      },

      {
        name: "URL",
        slug: "url",
        description:
          "QRGatewayの無料QRコードジェネレーターは、静的QRコードと動的QRコードの両方を作成できます。目的地のURLをいつでも変更できます。",
        title: "URLからQRコードを作成",
        keys: "URLからQRコード、URLからQRコードを生成、ウェブサイト用QRコード、ウェブサイトQRコードジェネレーター、無料URLからQRコード変換ツール、オンラインQRコード作成、ウェブサイト用動的QRコード、ウェブサイトURL用QRコード、カスタムウェブサイトQRコード、ランディングページ用QRコード、ブログ記事用QRコード、オンラインストア用QRコード、ソーシャルメディアプロファイル用QRコード、デジタルマーケティングキャンペーン用QRコード、イベント登録ページ用QRコード",
        h1: "URLからQRコード",
      },
      {
        name: "書類",
        slug: "document",
        description:
          "QRGatewayの無料QRコードジェネレーターを使用して、ドキュメント管理と共有を効率化しましょう。アップロードされたファイルのためにQRコードを即座に作成して、スキャンによるコンテンツへの簡単なアクセスを可能にします。",
        title: "ドキュメントからQRコードを作成",
        keys: "ドキュメントからQRコード、ファイルからQRコード、ドキュメント用QRコードジェネレーター、ドキュメントをQRコードに変換、無料ドキュメントQRコードジェネレーター、ファイル用オンラ",
        h1: "ドキュメントから QR コードへ",
      },
      {
        name: "画像",
        slug: "image",
        description:
          "QRGateway は、高度な機能を備えた QR コードに画像を変換します。テキストと画像を使用してプロモーション、行程、製品情報、またはイベントへのアクセスをスキャンします。QRGateway で無料のカスタム QR コードを作成します。",
        title: "ギャラリー画像から QR コードジェネレーター",
        keys: "QR コード, 画像を QR コードに変換, 画像 QR ジェネレーター, 画像から QR コードを作成, 画像を QR コードに変換する, 画像から QR へのコンバーター, 画像を QR コードに変換するツール, 画像用 QR コードメーカー, 写真を QR コードに変換, QR コード作成",
        h1: "画像を QR コードに",
      },
      {
        name: "オーディオとビデオ",
        slug: "multimedia",
        description:
          "QRGateway を使用して、オーディオまたはビデオ録音を共有可能な QR コードに変換できます。他の人がコードをスキャンしてファイルにアクセスできるように、メディアコンテンツを配布します。QRGateway のオーディオとビデオコード生成機能を使用すると、メディアの共有がこれまで以上に簡単になります。",
        title: "マルチメディアから QR コードジェネレーター",
        keys: "オーディオ QR コードジェネレーター, ビデオ QR コードジェネレーター, メディアを QR コードに変換, 共有可能な QR コード, QR コード共有, QR コードを使用したメディア共有, オーディオとビデオファイル用 QR コード, QR コードを使用したメディア配布, マルチメディアの QR コード生成",
        h1: "マルチメディアを QR コードに変換",
      },
      {
        name: "名刺",
        slug: "vcard",
        description:
          "QRGatewayを使えば、個人用または法人用の名刺を素早く無料で作成できます。簡単な共有、ビジター統計、コンタクトダイヤル、およびバッチ追加機能を楽しめます。ビジネスを拡大し、潜在的なクライアントとつながりましょう。",
        title: "ビジネスカードQRコードを作成する",
        keys: "ビジネスカードQRコード、ビジネスカードのQRコードジェネレータ、個人用ビジネスカードQRコード、法人用ビジネスカードQRコード、デジタルビジネスカードQRコード、スキャンして保存するビジネスカードQRコード、コンタクト共有QRコード、ビジター統計QRコード、バッチ追加QRコード、アドレス帳QRコード",
        h1: "あなたのVCardを作成する",
      },
      {
        name: "地図",
        slug: "map",
        description:
          "無料のジェネレーターを使用して、Google Mapsの任意の場所用のQRコードを作成できます。友達や顧客とお気に入りの場所を共有したり、マーケティング目的で使用したりすることができます。単に住所を入力し、デザインをカスタマイズしてQRコードをダウンロードします。",
        title: "GoogleマップをQRコードに変換する",
        keys: "GoogleマップQRコード、マップの場所QRコード、GoogleマップQRコードジェネレーター、GoogleマップをQRコードに埋め込む、ビジネスロケーションQRコード、モバイルフレンドリーなGoogleマップQRコード、GPS QRコード、ロケーション共有QRコード、旅行の予定QRコード、ナビゲーション用QRコード",
        h1: "GoogleマップをQRコードに変換する",
      },
      {
        name: "イベント",
        slug: "event",
        description: "イベントQRコードを通じてイベント体験を向上させる",
        title: "イベント用QRコードを作成する",
        keys: "イベントQRコード、イベント用QRコード、イベント管理を効率化、イベントチェックインソリューション",
        h1: "イベントQRコード",
      },
      {
        name: "Wifi",
        slug: "wifi",
        description:
          "使いやすいQRコードジェネレーターでWi-Fi情報の共有プロセスを簡素化する",
        title: "Wi-Fi用QRコードを作成する",
        keys: "Wi-Fi QRコード、QRコードジェネレーター、ネットワーク認証情報、Wi-Fiアクセス、無線接続、QRコードスキャナー、Wi-Fi共有、ネットワークセキュリティ、暗号化、簡単な接続性",
        h1: "Wi-Fi QRコード",
      },
      {
        name: "Email",
        slug: "email",
        description:
          "効率的なQRコードジェネレーターを使用して、利便性を高めてメールの共有を効率化する",
        title: "メール用QRコードを作成する",
        keys: "メールQRコード、QRコードジェネレーター、連絡先共有、メールアドレス",
        h1: "メールQRコード",
      },
      {
        name: "SMS",
        slug: "sms",
        description:
          "使いやすいQRコードジェネレーターでコミュニケーションを簡素化し、メッセージの配信を迅速化する",
        title: "SMS用QRコードを作成する",
        keys: "SMS QRコード、QRコードジェネレーター、メッセージ共有、SMS内容",
        h1: "SMS QRコード",
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        name: "Widget",
        slug: "",
        description:
          "通过添加徽标轻松个性化您的 QR 码，使您的扫描不仅具有功能性，而且具有视觉吸引力。",
        title: "QR Gateway - 带有徽标的免费SVG二维码生成器",
        keys: "QR码生成器,创建QR代码,免费QR码制造商,文本到QR码生成器,将文本转换为QR码,免费文本到QR码工具,QR码创作者,动态QR码,静态QR码",
        current: true,
        h1: "QR码生成器",
      },
      {
        name: "文本",
        slug: "text",
        description: "使用我们直观的工具轻松生成从纯文本到QR码。",
        title: "文本到QR码",
        keys: "QR码生成器，创建QR码，免费QR码制作工具，文本到QR码生成器，将文本转换为QR码，免费文本到QR码工具，QR码创作者，动态QR码，静态QR码",
        current: true,
        h1: "文本到QR码",
      },
      {
        name: "URL",
        slug: "url",
        description:
          "我们的免费QR码生成器可创建静态和动态QR码，允许您随时更改目标URL。",
        title: "URL到QR码生成器",
        keys: "URL到QR码,从URL生成QR码,网站QR码,网站QR码生成器,免费URL到QR码转换器,在线QR码生成器,网站动态QR码,网站URL的QR码,自定义网站QR码,着陆页QR码,博客文章QR码,在线商店QR码,QR码用于社交媒体资料QR码用于数字营销活动QR码用于活动注册页面",
        h1: "URL到QR码",
      },
      {
        name: "文档",
        slug: "document",
        description:
          "使用我们的免费QR码生成器QRGateway简化文档管理和共享。即时创建上传文件的QR码，通过扫描轻松访问内容。",
        title: "文档到QR码生成器",
        keys: "文档到QR码,文件到QR码,文档QR码生成器,将文档转换为QR码,免费文档QR码生成器,文件的在线QR码生成器,使用QR码共享文档,PDF,Word，Excel等的QR码，创建文档QR码，使用QR码管理文档，文件下载QR码，文件访问的QR码，文档的动态QR码，文档跟踪的QR码",
        h1: "文档到QR码",
      },
      {
        name: "图片",
        slug: "image",
        description:
          "QRGateway 将图片转换为具有高级功能的 QR 码。扫描以获取促销、行程、产品信息或事件，并附有文本和图片。使用 QRGateway 免费创建自定义 QR 码。",
        title: "图库图片转 QR 码生成器",
        keys: "QR 码、图片转 QR 码、图片 QR 生成器、从图片生成 QR 码、将图片转换为 QR 码、图片转 QR 工具、图片 QR 码生成器、将照片转换为 QR 码、图片转码转换器、图像转 QR 码",
        h1: "图片转 QR 码",
      },
      {
        name: "音视频",
        slug: "multimedia",
        description:
          "使用 QRGateway，将您的音频或视频记录转换为可共享的 QR 码。通过让其他人扫描该代码来分发您的媒体内容。使用QRGateway的音频和视频代码生成功能，共享媒体变得更加容易。",
        title: "多媒体转 QR 码生成器",
        keys: "音频 QR 码生成器、视频 QR 码生成器、将媒体转换为 QR 码、音频 QR 码生成器、视频 QR 码生成器、可共享的音频和视频 QR 码、通过 QR 码共享媒体、音频和视频文件的 QR 码、使用 QR 码分发媒体、多媒体的 QR 码生成",
        h1: "将多媒体转换为 QR 码",
      },

      {
        name: "名片",
        slug: "vcard",
        description:
          "使用我们快速、免费的名片生成器创建个人或企业名片。享受方便的分享、访客统计、联系电话和批量添加功能。今天扩展您的业务，连接潜在客户。",
        title: "创建名片二维码",
        keys: "名片二维码、名片二维码生成器、个人名片二维码、企业名片二维码、数字名片二维码、扫描保存名片二维码、联系人分享二维码、访客统计二维码、批量添加二维码、地址簿二维码",
        h1: "创建您的VCard",
      },
      {
        name: "地图",
        slug: "map",
        description:
          "使用我们的免费生成器为任何Google Maps位置创建QR代码。与朋友，客户或用于营销目的分享您喜爱的地方。只需输入地址，自定义设计并下载QR代码即可。",
        title: "Google Maps到QR码生成器",
        keys: "Google Map QR Code,地图位置QR码,Google Maps的QR码生成器,嵌入Google Maps的QR码,业务位置QR码,手机友好的Google Maps QR码,GPS QR码,位置共享QR码,旅行行程QR码,导航QR码",
        h1: "Google Map到QR码",
      },
      {
        name: "活动",
        slug: "event",
        description: "通过活动QR码提升您的活动体验",
        title: "为活动创建QR码",
        keys: "活动QR码、活动用QR码、简化活动管理、活动签到解决方案",
        h1: "活动QR码",
      },
      {
        name: "Wifi",
        slug: "wifi",
        description: "通过这款用户友好的QR码生成器，简化共享Wi-Fi信息的流程。",
        title: "为Wi-Fi创建QR码",
        keys: "Wi-Fi QR码、QR码生成器、网络凭证、Wi-Fi访问、无线连接、QR码扫描器、Wi-Fi共享、网络安全、加密、便捷连接",
        h1: "Wi-Fi QR码",
      },
      {
        name: "Email",
        slug: "email",
        description:
          "通过这款高效的QR码生成器，提升便利性并简化电子邮件的分享。",
        title: "为电子邮件创建QR码",
        keys: "电子邮件QR码、QR码生成器、联系人分享、电子邮件地址",
        h1: "电子邮件QR码",
      },
      {
        name: "SMS",
        slug: "sms",
        description: "通过这款用户友好的QR码生成器，简化沟通并加快消息传递。",
        title: "为短信创建QR码",
        keys: "短信QR码、QR码生成器、消息分享、短信内容",
        h1: "短信QR码",
      },
    ],
  },
];

const questions: Array<{
  locale: string;
  data: Array<{
    name: string;
    questions: Array<{
      question: string;
      answer: string;
    }>;
  }>;
}> = [
  {
    locale: "en",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "Why use QR codes?",
            answer:
              "QR codes are a simple and convenient technology for storing information. They can be easily scanned with a smartphone, making it easy to share information.",
          },
          {
            question: "Can I customize my QR code?",
            answer:
              "Yes, you can customize your QR code using online QR code generator tools such as QR Gateway. You can change the color, size, and shape of the QR code to match your preferences or branding.",
          },
          {
            question: "How can text, URL or files be converted into a QR code?",
            answer:
              "Text, URLs, and files can be converted into a QR code by entering the content into a QR code generator and generating the QR code. QR Gateway supports various file formats such as PDF, JPG, PNG...",
          },

          {
            question:
              "What other types of information can be contained in a QR code besides text?",
            answer:
              "In addition to text, QR codes can also contain website URLs, contact information, geographic coordinates, and other types of data.",
          },
          {
            question:
              "Can the information in a QR code be edited or updated after it has been created?",
            answer:
              "Yes, the information in the QR code can be edited or updated once created, but for static QR codes, changing the information will result in a new code and the image of the QR code will need to be updated as well.",
          },
          {
            question: "Is there a difference between QR codes and barcodes?",
            answer:
              "Yes, QR codes can store more information and be scanned more easily than barcodes. Barcodes contain information only horizontally, while QR codes can contain information both horizontally and vertically.",
          },
          {
            question: "What can QR codes be used for?",
            answer:
              "QR codes can be used for sharing information like website URLs, product details, contact information, payment information, and authentication, among other things. They are scannable using a smartphone camera and are also used in marketing and advertising.",
          },
          {
            question: "Can I create a QR code for a social media account?",
            answer:
              "Yes, you can generate a QR code for a social media account using QR Gateway's QR code generator tools and inserting a link to your account. Please visit app.qrgateway.com to sign up and use the service.",
          },
          {
            question: "Can QR codes be used to track pet information?",
            answer:
              "Yes, QR codes can be used to track information about domestic animals by inserting a QR code on them and scanning it to access information such as their origin, vaccination history, name, breed, weight, and medical records.",
          },
          {
            question:
              "Can QR codes be used for registering and checking membership card information?",
            answer:
              "Yes, QR codes can be used for registering and checking membership card information by embedding the QR code on the card and scanning it to access the member's information.",
          },
        ],
      },
      {
        name: "url",
        questions: [
          {
            question: "What is a URL to QR code converter?",
            answer:
              "A URL to QR code converter is a tool that allows users to convert a URL into a QR code that can be scanned and accessed through a mobile device.",
          },
          {
            question: "How does a URL to QR code converter work?",
            answer:
              "A URL to QR code converter works by taking a user-provided URL and converting it into a QR code image. This QR code can then be saved or printed and used to direct users to the original URL when scanned with a smartphone camera.",
          },
          {
            question: "Is QRGateway a free online URL to QR code converter?",
            answer:
              "QRGateway offers both free and paid plans for their URL to QR code converter service. The free plan allows users to generate up to 2 dynamic QR codes.",
          },
          {
            question:
              "Can a URL to QR code generator be used for marketing purposes?",
            answer:
              "Yes, a URL to QR code generator can be used for marketing purposes. By generating a QR code and placing it on marketing materials, users can easily access a website or landing page related to the product or service being promoted.",
          },
          {
            question:
              "Is it possible to customize the design of a QR code generated from a URL?",
            answer:
              "Yes, it is possible to customize the design of a QR code generated from a URL using a variety of colors, shapes, and logos to make it more visually appealing and on-brand.",
          },
          {
            question: "What types of URLs can be converted into a QR code?",
            answer:
              "Any type of URL can be converted into a QR code, including URLs for websites, social media profiles, videos, or any other online resource.",
          },
          {
            question:
              "What are some best practices to follow when using a URL to QR code converter for sharing links?",
            answer:
              "Some best practices to follow when using a URL to QR code converter for sharing links include keeping the URL short and simple, testing the QR code before printing or sharing it, and providing context or instructions for scanning the QR code.",
          },
          {
            question:
              "Is it necessary to have a mobile app to scan a QR code generated from a URL?",
            answer:
              "No, it is not necessary to have a mobile app to scan a QR code generated from a URL. Many smartphones now have built-in QR code readers in their cameras, and there are also a variety of free QR code reader apps available for download.",
          },
        ],
      },
      {
        name: "document",
        questions: [
          {
            question: "What is a document to QR code converter?",
            answer:
              "A document to QR code converter is an online tool that allows users to convert documents, such as PDFs, Word documents, or images, into QR codes that can be easily scanned and shared.",
          },
          {
            question: "How does a document to QR code converter work?",
            answer:
              "A document to QR code converter typically works by first uploading a document to the converter tool. The tool then converts the document into a QR code image that can be downloaded and shared.",
          },
          {
            question:
              "Can a document to QR code converter be used for confidential documents?",
            answer:
              "It is not recommended to use a document to QR code converter for confidential documents as the QR code can be easily scanned and accessed by anyone who has the code. If you must share confidential information, it is recommended to use a secure file sharing service.",
          },
          {
            question:
              "What types of documents can be converted into a QR code?",
            answer:
              "A document to QR code converter can typically convert a variety of document types, including PDFs, Word documents, images, and more.",
          },
          {
            question:
              "Is there a limit to the file size of a document that can be converted into a QR code?",
            answer:
              "There could be a restriction on the size of the file that can be converted to a QR code. We provide a clear notice regarding the acceptable file sizes.",
          },
          {
            question:
              "Can a document to QR code generator be used for marketing purposes?",
            answer:
              "Yes, a document to QR code generator can be used for marketing purposes by including the QR code on marketing materials such as flyers, brochures, or business cards to provide quick access to additional information or promotions.",
          },
        ],
      },
      {
        name: "multimedia",
        questions: [],
      },
      {
        name: "image",
        questions: [],
      },
      {
        name: "vcard",
        questions: [],
      },
      {
        name: "map",
        questions: [],
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "Tại sao sử dụng mã QR?",
            answer:
              "Mã QR là công nghệ đơn giản và tiện lợi để lưu trữ thông tin. Chúng có thể dễ dàng quét bằng điện thoại thông minh, làm cho việc chia sẻ thông tin trở nên dễ dàng.",
          },
          {
            question: "Tôi có thể tùy chỉnh mã QR của mình không?",
            answer:
              "Có, bạn có thể tùy chỉnh mã QR của mình bằng cách sử dụng các công cụ tạo mã QR trực tuyến như QR Gateway. Bạn có thể thay đổi màu sắc, kích thước và hình dạng của mã QR để phù hợp với sở thích hoặc thương hiệu của bạn.",
          },
          {
            question:
              "Làm thế nào để chuyển đổi văn bản, URL hoặc tệp thành mã QR?",
            answer:
              "Văn bản, URL và tệp có thể được chuyển đổi thành mã QR bằng cách nhập nội dung vào trình tạo mã QR và tạo mã QR. QR Gateway hỗ trợ nhiều định dạng tệp như PDF, JPG, PNG...",
          },
          {
            question:
              "Loại thông tin nào khác có thể chứa trong mã QR ngoài văn bản?",
            answer:
              "Ngoài văn bản, mã QR cũng có thể chứa địa chỉ URL trang web, thông tin liên lạc, tọa độ địa lý và các loại dữ liệu khác.",
          },
          {
            question:
              "Thông tin trong mã QR có thể chỉnh sửa hoặc cập nhật sau khi đã được tạo ra không?",
            answer:
              "Có, thông tin trong mã QR có thể chỉnh sửa hoặc cập nhật sau khi được tạo ra, nhưng đối với mã QR tĩnh, thay đổi thông tin sẽ dẫn đến tạo ra một mã QR mới và hình ảnh của mã QR sẽ cần được cập nhật.",
          },
          {
            question: "Có khác biệt gì giữa mã QR và mã vạch?",
            answer:
              "Có, mã QR có thể lưu trữ nhiều thông tin hơn và được quét dễ dàng hơn so với mã vạch. Mã vạch chỉ chứa thông tin theo chiều ngang, trong khi mã QR có thể chứa thông tin cả chiều ngang và chiều dọc.",
          },
          {
            question: "QR codes có thể được sử dụng cho mục đích gì?",
            answer:
              "QR codes có thể được sử dụng để chia sẻ thông tin như địa chỉ website, chi tiết sản phẩm, thông tin liên hệ, thông tin thanh toán và xác thực, và nhiều mục đích khác. Chúng có thể được quét bằng camera smartphone và cũng được sử dụng trong marketing và quảng cáo.",
          },
          {
            question: "Tôi có thể tạo QR code cho tài khoản mạng xã hội không?",
            answer:
              "Có, bạn có thể tạo QR code cho tài khoản mạng xã hội bằng các công cụ tạo QR code của QR Gateway và chèn đường link đến tài khoản của bạn. Vui lòng truy cập app.qrgateway.com để đăng ký và sử dụng dịch vụ.",
          },
          {
            question:
              "QR codes có thể được sử dụng để theo dõi thông tin về thú cưng không?",
            answer:
              "Có, QR codes có thể được sử dụng để theo dõi thông tin về động vật nuôi bằng cách chèn mã QR trên chúng và quét nó để truy cập thông tin như nguồn gốc, lịch sử tiêm phòng, tên, giống, trọng lượng và hồ sơ y tế.",
          },
          {
            question:
              "QR codes có thể được sử dụng để đăng ký và kiểm tra thông tin thẻ thành viên không?",
            answer:
              "Có, QR codes có thể được sử dụng để đăng ký và kiểm tra thông tin thẻ thành viên bằng cách nhúng mã QR vào thẻ và quét nó để truy cập thông tin thành viên.",
          },
        ],
      },
    ],
  },
  {
    locale: "fr",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "Pourquoi utiliser des codes QR ?",
            answer:
              "Les codes QR sont une technologie simple et pratique pour stocker des informations. Ils peuvent être facilement scannés avec un smartphone, ce qui permet de partager facilement des informations.",
          },
          {
            question: "Puis-je personnaliser mon code QR ?",
            answer:
              "Oui, vous pouvez personnaliser votre code QR en utilisant des outils de génération de code QR en ligne tels que QR Gateway. Vous pouvez changer la couleur, la taille et la forme du code QR pour correspondre à vos préférences ou à votre branding.",
          },
          {
            question:
              "Comment convertir du texte, une URL ou des fichiers en code QR ?",
            answer:
              "Le texte, les URL et les fichiers peuvent être convertis en code QR en entrant le contenu dans un générateur de code QR et en générant le code QR. QR Gateway prend en charge différents formats de fichiers tels que PDF, JPG, PNG...",
          },
          {
            question:
              "Quels autres types d'informations peuvent être contenus dans un code QR en dehors du texte ?",
            answer:
              "En plus du texte, les codes QR peuvent également contenir des URL de site web, des informations de contact, des coordonnées géographiques et d'autres types de données.",
          },
          {
            question:
              "L'information dans un code QR peut-elle être modifiée ou mise à jour une fois qu'elle a été créée ?",
            answer:
              "Oui, l'information dans le code QR peut être modifiée ou mise à jour une fois créée, mais pour les codes QR statiques, changer l'information entraînera un nouveau code et l'image du code QR devra également être mise à jour.",
          },
          {
            question:
              "Y a-t-il une différence entre les codes QR et les codes-barres ?",
            answer:
              "Oui, les codes QR peuvent stocker plus d'informations et être scannés plus facilement que les codes-barres. Les codes-barres ne contiennent des informations que horizontalement, tandis que les codes QR peuvent contenir des informations à la fois horizontalement et verticalement.",
          },
          {
            question: "À quoi peuvent servir les codes QR?",
            answer:
              "Les codes QR peuvent servir à partager des informations telles que des URL de site Web, des détails de produits, des informations de contact, des informations de paiement et d'authentification, entre autres. Ils sont scannables à l'aide de l'appareil photo d'un smartphone et sont également utilisés dans le marketing et la publicité.",
          },
          {
            question:
              "Puis-je créer un code QR pour un compte de médias sociaux?",
            answer:
              "Oui, vous pouvez générer un code QR pour un compte de médias sociaux en utilisant les outils de générateur de code QR de QR Gateway et en insérant un lien vers votre compte. Veuillez visiter app.qrgateway.com pour vous inscrire et utiliser le service.",
          },
          {
            question:
              "Les codes QR peuvent-ils être utilisés pour suivre les informations des animaux domestiques?",
            answer:
              "Oui, les codes QR peuvent être utilisés pour suivre les informations sur les animaux domestiques en insérant un code QR sur eux et en le scannant pour accéder à des informations telles que leur origine, leur historique de vaccination, leur nom, leur race, leur poids et leurs dossiers médicaux.",
          },
          {
            question:
              "Les codes QR peuvent-ils être utilisés pour l'inscription et la vérification des informations de carte de membre?",
            answer:
              "Oui, les codes QR peuvent être utilisés pour l'inscription et la vérification des informations de carte de membre en incorporant le code QR sur la carte et en le scannant pour accéder aux informations du membre.",
          },
        ],
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "Why use QR codes?",
            answer:
              "QR-Codes sind eine einfache und bequeme Technologie zur Speicherung von Informationen. Sie können leicht mit einem Smartphone gescannt werden und ermöglichen somit das einfache Teilen von Informationen.",
          },
          {
            question: "Can I customize my QR code?",
            answer:
              "Ja, Sie können Ihren QR-Code mithilfe von Online-QR-Code-Generatoren wie QR Gateway anpassen. Sie können Farbe, Größe und Form des QR-Codes nach Ihren Vorlieben oder Ihrer Marke ändern.",
          },
          {
            question: "How can text, URL or files be converted into a QR code?",
            answer:
              "Texte, URLs und Dateien können in einen QR-Code umgewandelt werden, indem der Inhalt in einen QR-Code-Generator eingegeben und der QR-Code generiert wird. QR Gateway unterstützt verschiedene Dateiformate wie PDF, JPG, PNG...",
          },
          {
            question:
              "What other types of information can be contained in a QR code besides text?",
            answer:
              "Neben Text können QR-Codes auch Website-URLs, Kontaktdaten, geografische Koordinaten und andere Arten von Daten enthalten.",
          },
          {
            question:
              "Can the information in a QR code be edited or updated after it has been created?",
            answer:
              "Ja, die Informationen im QR-Code können nach der Erstellung bearbeitet oder aktualisiert werden. Für statische QR-Codes führt die Änderung der Informationen jedoch zu einem neuen Code, und das Bild des QR-Codes muss ebenfalls aktualisiert werden.",
          },
          {
            question: "Is there a difference between QR codes and barcodes?",
            answer:
              "Ja, QR-Codes können mehr Informationen speichern und einfacher gescannt werden als Barcodes. Barcodes enthalten nur horizontal Informationen, während QR-Codes sowohl horizontal als auch vertikal Informationen enthalten können.",
          },
          {
            question: "Wofür können QR-Codes verwendet werden?",
            answer:
              "QR-Codes können für das Teilen von Informationen wie Website-URLs, Produktinformationen, Kontaktinformationen, Zahlungsinformationen und Authentifizierung sowie für andere Dinge verwendet werden. Sie sind mit einer Smartphone-Kamera scannbar und werden auch in Marketing und Werbung eingesetzt.",
          },
          {
            question:
              "Kann ich einen QR-Code für ein Social-Media-Konto erstellen?",
            answer:
              "Ja, Sie können einen QR-Code für ein Social-Media-Konto mit den QR-Code-Generator-Tools von QR Gateway generieren und einen Link zu Ihrem Konto einfügen. Bitte besuchen Sie app.qrgateway.com, um sich anzumelden und den Service zu nutzen.",
          },
          {
            question:
              "Können QR-Codes verwendet werden, um Informationen über Haustiere zu verfolgen?",
            answer:
              "Ja, QR-Codes können verwendet werden, um Informationen über Haustiere zu verfolgen, indem ein QR-Code auf ihnen platziert und gescannt wird, um Informationen wie ihren Ursprung, Impfgeschichte, Namen, Rasse, Gewicht und medizinische Aufzeichnungen abzurufen.",
          },
          {
            question:
              "Können QR-Codes für die Registrierung und Überprüfung von Mitgliedskarteninformationen verwendet werden?",
            answer:
              "Ja, QR-Codes können verwendet werden, um Mitgliedskarteninformationen zu registrieren und zu überprüfen, indem der QR-Code auf der Karte eingebettet und gescannt wird, um auf die Informationen des Mitglieds zuzugreifen.",
          },
        ],
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "Perché usare i codici QR?",
            answer:
              "I codici QR sono una tecnologia semplice e conveniente per memorizzare informazioni. Possono essere facilmente scannerizzati con uno smartphone, rendendo facile la condivisione di informazioni.",
          },
          {
            question: "Posso personalizzare il mio codice QR?",
            answer:
              "Sì, puoi personalizzare il tuo codice QR utilizzando strumenti online per la generazione di codici QR come QR Gateway. Puoi cambiare il colore, la dimensione e la forma del codice QR per adattarlo alle tue preferenze o al tuo marchio.",
          },
          {
            question:
              "Come si possono convertire testo, URL o file in un codice QR?",
            answer:
              "Testo, URL e file possono essere convertiti in un codice QR inserendo il contenuto in un generatore di codici QR e generando il codice QR. QR Gateway supporta vari formati di file come PDF, JPG, PNG...",
          },
          {
            question:
              "Quali altri tipi di informazioni possono essere contenuti in un codice QR oltre al testo?",
            answer:
              "Oltre al testo, i codici QR possono contenere anche URL di siti web, informazioni di contatto, coordinate geografiche e altri tipi di dati.",
          },
          {
            question:
              "È possibile modificare o aggiornare le informazioni in un codice QR dopo che è stato creato?",
            answer:
              "Sì, le informazioni nel codice QR possono essere modificate o aggiornate una volta creato, ma per i codici QR statici, la modifica delle informazioni comporterà la creazione di un nuovo codice e l'immagine del codice QR dovrà essere aggiornata anche essa.",
          },
          {
            question: "C'è una differenza tra i codici QR e i codici a barre?",
            answer:
              "Sì, i codici QR possono memorizzare più informazioni e essere scannerizzati più facilmente rispetto ai codici a barre. I codici a barre contengono informazioni solo in orizzontale, mentre i codici QR possono contenere informazioni sia in orizzontale che in verticale.",
          },
          {
            question: "Per cosa possono essere utilizzati i codici QR?",
            answer:
              "I codici QR possono essere utilizzati per condividere informazioni come URL del sito web, dettagli del prodotto, informazioni di contatto, informazioni di pagamento e autenticazione, tra le altre cose. Sono scansionabili utilizzando la fotocamera dello smartphone e vengono anche utilizzati nel marketing e nella pubblicità.",
          },
          {
            question:
              "Posso creare un codice QR per un account sui social media?",
            answer:
              "Sì, è possibile generare un codice QR per un account sui social media utilizzando gli strumenti di generazione di codici QR di QR Gateway e inserendo un collegamento al proprio account. Si prega di visitare il sito app.qrgateway.com per registrarsi e utilizzare il servizio.",
          },
          {
            question:
              "I codici QR possono essere utilizzati per tenere traccia delle informazioni sugli animali domestici?",
            answer:
              "Sì, i codici QR possono essere utilizzati per tenere traccia delle informazioni sugli animali domestici inserendo un codice QR su di loro e scansionandolo per accedere a informazioni come la loro origine, la loro storia di vaccinazione, il loro nome, la razza, il peso e le cartelle cliniche.",
          },
          {
            question:
              "I codici QR possono essere utilizzati per registrare e controllare le informazioni sulla tessera di membri?",
            answer:
              "Sì, i codici QR possono essere utilizzati per registrare e controllare le informazioni sulla tessera di membri incorporando il codice QR sulla tessera e scansionandolo per accedere alle informazioni del membro.",
          },
        ],
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "¿Por qué usar códigos QR?",
            answer:
              "Los códigos QR son una tecnología simple y conveniente para almacenar información. Se pueden escanear fácilmente con un smartphone, lo que facilita compartir información.",
          },
          {
            question: "¿Puedo personalizar mi código QR?",
            answer:
              "Sí, puedes personalizar tu código QR utilizando herramientas en línea generadoras de códigos QR como QR Gateway. Puedes cambiar el color, tamaño y forma del código QR para que coincida con tus preferencias o marca.",
          },
          {
            question:
              "¿Cómo se pueden convertir el texto, la URL o los archivos en un código QR?",
            answer:
              "El texto, las URL y los archivos se pueden convertir en un código QR ingresando el contenido en un generador de códigos QR y generando el código QR. QR Gateway admite varios formatos de archivo como PDF, JPG, PNG...",
          },
          {
            question:
              "¿Qué otros tipos de información se pueden incluir en un código QR además del texto?",
            answer:
              "Además del texto, los códigos QR también pueden contener URL de sitios web, información de contacto, coordenadas geográficas y otros tipos de datos.",
          },
          {
            question:
              "¿Se puede editar o actualizar la información en un código QR después de haber sido creado?",
            answer:
              "Sí, la información en el código QR se puede editar o actualizar una vez creado, pero para códigos QR estáticos, cambiar la información resultará en un nuevo código y la imagen del código QR también deberá actualizarse.",
          },
          {
            question:
              "¿Hay alguna diferencia entre los códigos QR y los códigos de barras?",
            answer:
              "Sí, los códigos QR pueden almacenar más información y ser escaneados con más facilidad que los códigos de barras. Los códigos de barras solo contienen información horizontal, mientras que los códigos QR pueden contener información tanto horizontal como verticalmente.",
          },
          {
            question: "¿Para qué se pueden usar los códigos QR?",
            answer:
              "Los códigos QR se pueden usar para compartir información como URL de sitios web, detalles de productos, información de contacto, información de pago y autenticación, entre otras cosas. Se pueden escanear con la cámara de un teléfono inteligente y también se utilizan en marketing y publicidad.",
          },
          {
            question:
              "¿Puedo crear un código QR para una cuenta de redes sociales?",
            answer:
              "Sí, puede generar un código QR para una cuenta de redes sociales utilizando las herramientas generadoras de códigos QR de QR Gateway e insertando un enlace a su cuenta. Visite app.qrgateway.com para registrarse y utilizar el servicio.",
          },
          {
            question:
              "¿Se pueden usar los códigos QR para rastrear la información de las mascotas?",
            answer:
              "Sí, los códigos QR se pueden usar para rastrear información sobre animales domésticos insertando un código QR en ellos y escaneándolo para acceder a información como su origen, historial de vacunación, nombre, raza, peso y registros médicos.",
          },
          {
            question:
              "¿Se pueden usar los códigos QR para registrar y verificar información de tarjetas de membresía?",
            answer:
              "Sí, los códigos QR se pueden usar para registrar y verificar la información de la tarjeta de membresía insertando el código QR en la tarjeta y escaneándolo para acceder a la información del miembro.",
          },
        ],
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "Por que usar códigos QR?",
            answer:
              "Códigos QR são uma tecnologia simples e conveniente para armazenar informações. Eles podem ser facilmente escaneados com um smartphone, tornando fácil compartilhar informações.",
          },
          {
            question: "Posso personalizar meu código QR?",
            answer:
              "Sim, você pode personalizar seu código QR usando ferramentas geradoras de código QR on-line, como o QR Gateway. Você pode alterar a cor, o tamanho e a forma do código QR para corresponder às suas preferências ou marca.",
          },
          {
            question:
              "Como textos, URLs ou arquivos podem ser convertidos em um código QR?",
            answer:
              "Textos, URLs e arquivos podem ser convertidos em um código QR digitando o conteúdo em um gerador de código QR e gerando o código QR. O QR Gateway suporta vários formatos de arquivo, como PDF, JPG, PNG...",
          },
          {
            question:
              "Que outros tipos de informações podem ser contidos em um código QR além de texto?",
            answer:
              "Além do texto, códigos QR também podem conter URLs de sites, informações de contato, coordenadas geográficas e outros tipos de dados.",
          },
          {
            question:
              "As informações em um código QR podem ser editadas ou atualizadas após a criação?",
            answer:
              "Sim, as informações no código QR podem ser editadas ou atualizadas depois de criadas, mas para códigos QR estáticos, alterar as informações resultará em um novo código e a imagem do código QR precisará ser atualizada também.",
          },
          {
            question:
              "Existe alguma diferença entre códigos QR e códigos de barras?",
            answer:
              "Sim, códigos QR podem armazenar mais informações e serem digitalizados mais facilmente do que códigos de barras. Códigos de barras contêm informações apenas horizontalmente, enquanto códigos QR podem conter informações tanto horizontal quanto verticalmente.",
          },
          {
            question: "Para que se pueden utilizar los códigos QR?",
            answer:
              "Los códigos QR se pueden utilizar para compartir información como direcciones web, detalles de productos, información de contacto, información de pago y autenticación, entre otras cosas. Son escaneables mediante la cámara de un smartphone y también se utilizan en marketing y publicidad.",
          },
          {
            question:
              "¿Puedo crear un código QR para una cuenta de redes sociales?",
            answer:
              "Sí, se puede generar un código QR para una cuenta de redes sociales utilizando las herramientas generadoras de códigos QR de QR Gateway e insertando un enlace a la cuenta. Visite app.qrgateway.com para registrarse y utilizar el servicio.",
          },
          {
            question:
              "¿Se pueden utilizar los códigos QR para rastrear información de mascotas?",
            answer:
              "Sí, los códigos QR se pueden utilizar para rastrear información sobre animales domésticos mediante la inserción de un código QR en ellos y escaneándolo para acceder a información como su origen, historial de vacunación, nombre, raza, peso y registros médicos.",
          },
          {
            question:
              "¿Se pueden utilizar los códigos QR para registrar y comprobar la información de la tarjeta de membresía?",
            answer:
              "Sí, los códigos QR se pueden utilizar para registrar y comprobar la información de la tarjeta de membresía mediante la inserción del código QR en la tarjeta y escaneándolo para acceder a la información del miembro.",
          },
        ],
      },
    ],
  },
  {
    locale: "nl",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "Waarom QR-codes gebruiken?",
            answer:
              "QR-codes zijn een eenvoudige en handige technologie om informatie op te slaan. Ze kunnen gemakkelijk worden gescand met een smartphone, waardoor het gemakkelijk is om informatie te delen.",
          },
          {
            question: "Kan ik mijn QR-code aanpassen?",
            answer:
              "Ja, u kunt uw QR-code aanpassen met online QR-codegenerator tools zoals QR Gateway. U kunt de kleur, grootte en vorm van de QR-code aanpassen aan uw voorkeuren of merk.",
          },
          {
            question:
              "Hoe kunnen tekst, URL of bestanden worden omgezet in een QR-code?",
            answer:
              "Tekst, URL's en bestanden kunnen worden omgezet in een QR-code door de inhoud in te voeren in een QR-codegenerator en de QR-code te genereren. QR Gateway ondersteunt verschillende bestandsformaten zoals PDF, JPG, PNG...",
          },
          {
            question:
              "Welke andere soorten informatie kunnen worden opgenomen in een QR-code behalve tekst?",
            answer:
              "Naast tekst kunnen QR-codes ook website-URL's, contactgegevens, geografische coördinaten en andere soorten gegevens bevatten.",
          },
          {
            question:
              "Kan de informatie in een QR-code worden bewerkt of bijgewerkt nadat deze is gemaakt?",
            answer:
              "Ja, de informatie in de QR-code kan worden bewerkt of bijgewerkt nadat deze is gemaakt, maar voor statische QR-codes zal het wijzigen van de informatie resulteren in een nieuwe code en moet ook de afbeelding van de QR-code worden bijgewerkt.",
          },
          {
            question: "Is er een verschil tussen QR-codes en barcodes?",
            answer:
              "Ja, QR-codes kunnen meer informatie bevatten en gemakkelijker worden gescand dan barcodes. Barcodes bevatten alleen informatie horizontaal, terwijl QR-codes zowel horizontaal als verticaal informatie kunnen bevatten.",
          },
          {
            question: "Waarvoor kunnen QR-codes worden gebruikt?",
            answer:
              "QR-codes kunnen worden gebruikt om informatie te delen, zoals website-URL's, productdetails, contactinformatie, betaalinformatie en authenticatie, onder andere. Ze kunnen worden gescand met behulp van de camera van een smartphone en worden ook gebruikt in marketing en advertenties.",
          },
          {
            question: "Can I create a QR code for a social media account?",
            answer:
              "Ja, je kunt een QR-code genereren voor een social media-account met behulp van de QR-code generator-tools van QR Gateway en een link naar je account invoegen. Ga naar app.qrgateway.com om je aan te melden en de service te gebruiken.",
          },
          {
            question: "Can QR codes be used to track pet information?",
            answer:
              "Ja, QR-codes kunnen worden gebruikt om informatie over huisdieren te volgen door een QR-code op hen te plaatsen en deze te scannen om toegang te krijgen tot informatie zoals hun oorsprong, vaccinatiegeschiedenis, naam, ras, gewicht en medische gegevens.",
          },
          {
            question:
              "Can QR codes be used for registering and checking membership card information?",
            answer:
              "Ja, QR-codes kunnen worden gebruikt voor het registreren en controleren van lidmaatschapskaartinformatie door de QR-code op de kaart in te bedden en deze te scannen om toegang te krijgen tot de informatie van de leden.",
          },
        ],
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "Why use QR codes?",
            answer:
              "QRコードは情報を簡単に保存するためのシンプルで便利なテクノロジーです。スマートフォンで簡単にスキャンできるため、情報を共有するのも簡単です。",
          },
          {
            question: "Can I customize my QR code?",
            answer:
              "はい、QR GatewayなどのオンラインQRコードジェネレーターツールを使用して、QRコードの色、サイズ、形状をカスタマイズできます。あなたの好みやブランディングに合わせて変更することができます。",
          },
          {
            question: "How can text, URL or files be converted into a QR code?",
            answer:
              "テキスト、URL、ファイルはQRコードジェネレーターに入力してQRコードに変換することができます。QR Gatewayは、PDF、JPG、PNGなど、さまざまなファイル形式をサポートしています。",
          },
          {
            question:
              "What other types of information can be contained in a QR code besides text?",
            answer:
              "テキスト以外にも、QRコードにはウェブサイトのURL、連絡先情報、地理座標、その他の種類のデータを含めることができます。",
          },
          {
            question:
              "Can the information in a QR code be edited or updated after it has been created?",
            answer:
              "QRコード内の情報は作成後に編集または更新することができます。ただし、静的QRコードの場合、情報を変更すると新しいコードが作成され、QRコードの画像も更新する必要があります。",
          },
          {
            question: "Is there a difference between QR codes and barcodes?",
            answer:
              "はい、QRコードはバーコードよりも多くの情報を保存でき、より簡単にスキャンできます。バーコードは水平方向の情報のみを含みますが、QRコードは水平方向と垂直方向の情報を含むことができます。",
          },
          {
            question: "QRコードは何に使われますか？",
            answer:
              "QRコードは、ウェブサイトのURL、製品詳細、連絡先情報、支払い情報、認証などの情報を共有するために使用できます。スマートフォンのカメラでスキャンでき、マーケティングや広告でも使用されています。",
          },
          {
            question:
              "ソーシャルメディアアカウントのためにQRコードを作成できますか？",
            answer:
              "はい、QR GatewayのQRコードジェネレーターツールを使用して、アカウントへのリンクを挿入することで、ソーシャルメディアアカウントのためにQRコードを生成できます。サービスを利用するには、app.qrgateway.comを訪問して登録してください。",
          },
          {
            question: "QRコードはペット情報の追跡に使用できますか？",
            answer:
              "はい、QRコードを挿入してスキャンすることで、家庭用動物の情報を追跡するためにQRコードを使用できます。出身地、ワクチンの歴史、名前、品種、体重、医療記録などの情報にアクセスできます。",
          },
          {
            question: "QRコードは会員カード情報の登録と確認に使用できますか？",
            answer:
              "はい、QRコードをカードに埋め込んでスキャンすることで、会員の情報にアクセスして会員カード情報を登録および確認することができます。",
          },
        ],
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        name: "text",
        questions: [
          {
            question: "为什么使用QR码？",
            answer:
              "QR码是一种简单方便的技术，用于存储信息。它们可以很容易地用智能手机扫描，使得分享信息变得容易。",
          },
          {
            question: "我可以自定义我的QR码吗？",
            answer:
              "是的，您可以使用在线QR码生成工具（例如QR Gateway）自定义QR码。您可以更改QR码的颜色、大小和形状，以匹配您的偏好或品牌。",
          },
          {
            question: "如何将文本、URL或文件转换为QR码？",
            answer:
              "通过将内容输入QR码生成器并生成QR码，可以将文本、URL和文件转换为QR码。QR Gateway支持各种文件格式，例如PDF、JPG、PNG...",
          },
          {
            question: "QR码除了文本外还能包含哪些其他类型的信息？",
            answer:
              "除了文本，QR码还可以包含网站URL、联系信息、地理坐标和其他类型的数据。",
          },
          {
            question: "创建后可以编辑或更新QR码中的信息吗？",
            answer:
              "是的，一旦创建了QR码，其中的信息可以进行编辑或更新，但对于静态QR码，更改信息将导致一个新的QR码，QR码的图像也需要更新。",
          },
          {
            question: "QR码和条形码有什么区别？",
            answer:
              "是的，QR码可以存储更多的信息，并且比条形码更容易扫描。条形码只能包含水平信息，而QR码可以包含水平和垂直信息。",
          },
          {
            question: "QR码可以用来做什么？",
            answer:
              "QR码可以用于共享信息,如网站URL、产品详情、联系信息、支付信息和身份验证等。它们可使用智能手机相机进行扫描,也用于市场营销和广告。",
          },
          {
            question: "我可以为社交媒体账户创建QR码吗？",
            answer:
              "是的,您可以使用QR Gateway的QR码生成器工具为社交媒体账户创建QR码,并插入您的账户链接。请访问app.qrgateway.com注册并使用该服务。",
          },
          {
            question: "QR码可以用于跟踪宠物信息吗？",
            answer:
              "是的,可以通过在宠物身上插入QR码并扫描它来跟踪有关家庭宠物的信息,例如它们的来源、疫苗史、姓名、品种、体重和医疗记录等。",
          },
          {
            question: "QR码可以用于注册和检查会员卡信息吗？",
            answer:
              "是的,可以通过在会员卡上嵌入QR码并扫描它来注册和检查会员卡信息,以访问会员的信息。",
          },
        ],
      },
    ],
  },
];
